import React, { Component } from 'react';
import Service from '../../services';
import withRouter from '../../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { paymentModes } from '../../../constants';
import { Button } from 'primereact/button';
import { baseUrlAdmin } from '../../../store/apiConstants';
import moment from 'moment';
import { AddIcon2, CrossInBox, FileAttachmentIcon, RightMarkInCircle, StarInfoBadge } from '../../svgIcons';
import { getFormFields, isFormValid, onDropDownChange, onTextChange, onEmailChange } from '../../../utile/formHelper';
import { Dialog } from 'primereact/dialog';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { Toast } from 'primereact/toast';
import SafeToast from './SafeToast';
import LoadingComponent from '../../loadingComponent';
import FeeReciept from '../receipt';
import { BasicLazyParams, trimObj } from '../../../utile';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import asymmetricEncryptionUtils from '../../../utils/asymmetricEncryptionUtils';
import { ProgressSpinner } from 'primereact/progressspinner';
import FileUpload from '../../fileUpload';
import ClassetCalendar from '../../../classetComponents/classetCalender';
// import NTTPaymentComponent from '../../NTTPaymentComponent/NTTPaymentComponent';
import NTTPaymentComponent from '../../financeManagement/NTTPaymentComponent';


import castes from '../../../constants/castes.json';
import religions from '../../../constants/religions.json';
import states from '../../../constants/states.json';
import districts from '../../../constants/districts.json';
import cityOrDist from '../../../constants/cityOrDist.json';
import area from '../../../constants/area.json';
import countryPhoneCodes from '../../../constants/countryPhoneCodes.json';
import countries from '../../../constants/countries.json';
import motherTongue from '../../../constants/motherTongue.json';
// import gradesEnum from '../../../constants/grades.json';
import gradesEnum from '../../../constants/grades.json';
import { fetchStudents } from '../../../store/actions/studentActions';
import { set } from 'lodash';

// ...existing imports...

const createFields = require('./collectFee.json');

const createEnrollmentFields = require('./enrollmentCreate.json');

const formFields = createEnrollmentFields
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
const profilesBucket = process.env.REACT_APP_PROFILES_BUCKET || 'classet-profiles-old';

class ConfirmEnrollment extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(createEnrollmentFields);
        this.payformFields = getFormFields(createFields);

        const transformedCountryPhoneCodes = countryPhoneCodes.map(country => ({
            label: `${country.country} (+${country.code})`,
            value: country.code,
            country: country.country,
            iso: country.iso
        }));

        const transformedMotherTongue = motherTongue.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        const transformedCastes = castes.map(caste => ({
            label: caste.label,
            value: caste.value
        }));

        const transformedReligions = religions.map(religion => ({
            label: religion.label,
            value: religion.value
        }));

        const transformedCountries = countries.map(country => ({
            name: country.name,
            code: country.code
        }));

        const transformedStates = states.map(state => ({
            label: state.label,
            value: state.value
        }));

        const transformedCityOrDist = cityOrDist.map(city => ({
            label: city.label,
            value: city.value
        }));

        const transformedArea = area.map(area => ({
            label: area.label,
            value: area.value
        }));

        // Transform grades from grades.json for classStudyingDrp
        const transformedGrades = Object.entries(gradesEnum).map(([label, value]) => ({
            label: label,
            value: value
        }));

        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            isOpenPayFeeDailog: false,
            enrollment: this.formFields.data,
            viewEnrollment: false,
            payFeeFormData: this.payformFields.data,
            payFee: this.payformFields.data,
            payFormValidations: this.payformFields.formValidations,
            formValidations: this.formFields.formValidations,
            isEnrollmentFeePaid: false,
            isShowPayFeeButton: false,
            isShowFeeStructure: false,
            isFeeDialogMaximized: true,
            isOptedForTransport: false,
            isCredeintalsDisplay: false,
            studentDetails: false,
            userCreatedInfo: {},
            feeStructureR: [],
            isStudentEnrolledConfirmed: false,
            isCloseOfFeeStructure: false,
            academicCategory: [], // Make sure this is initialized as an empty array

            // Branch/Board/Class related state
            boards: [], // Initialize boards array
            classes: [], // Initialize classes array
            branchId: '',
            selectedbranchName: '',
            boardId: '',
            selectedBoardName: '',
            classId: '',
            selectedClass: {},
            selectedClassName: '',
            groupId: '',

            // Dropdown data
            countryPhoneCodes: transformedCountryPhoneCodes,
            motherTongue: transformedMotherTongue,
            castes: transformedCastes,
            religions: transformedReligions,
            countries: transformedCountries,
            state: transformedStates,
            cityOrDist: transformedCityOrDist,
            area: transformedArea,

            // Form arrays
            parents: [
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    countryCode: '',
                    parentContact: '',
                    parentEmailId: '',
                }
            ],
            parentValidations: [{}], // Validation state for each parent
            siblings: [
                { name: "", gender: "", classStudying: "", schoolStudying: "" }
            ],

            // Static dropdown options
            govtIdTypes: [
                { label: "Aadhaar Card", value: "aadhaar" },
                { label: "Passport", value: "passport" },
                { label: "Other", value: "other" }
            ],
            gender: [
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Other', value: 'other' }

            ],
            parentTypes: [
                { label: 'Father', value: 'Father' },
                { label: 'Mother', value: 'Mother' },
                { label: 'Guardian', value: 'Guardian' }
            ],
            previousBoards: [
                { label: "Central Board of Secondary Education (CBSE)", value: "CBSE" },
                { label: "Indian Certificate of Secondary Education (ICSE)", value: "ICSE" },
                { label: "International Baccalaureate (IB)", value: "IB" },
                { label: "Cambridge Assessment International Education (IGCSE)", value: "IGCSE" },
                { label: "State Board", value: "State" },
                { label: "National Institute of Open Schooling (NIOS)", value: "NIOS" },
                { label: "Council for the Indian School Certificate Examinations (CISCE)", value: "CISCE" },
                { label: "Other", value: "Other" },
            ],
            genderData: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" }
            ],
            classStudyingDrp: transformedGrades,
            showNTTPayment: false,
            nttPaymentData: null,
            selectedClassesList: [],
            dob: null,
            ageCriteriaInfo: []
        };
        this.service = new Service();
        this.safeToast = React.createRef();

        // Helper method to safely show toast messages
        this.showToast = (options) => {
            if (this.safeToast.current) {
                this.safeToast.current.show(options);
            } else if (this.toast) {
                this.toast.show(options);
            } else {
                console.error('Toast notification:', options);
            }
        }

        // Monkeypatch this.toast to prevent null reference errors
        // Create a proxy object for toast that catches all show calls
        this.toast = {
            show: (options) => {
                this.showToast(options);
            }
        };
    }

    async componentDidMount() {
        // Check for payment redirect from NTT gateway
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get('status');
        const txnId = urlParams.get('txnId');
        const atomTxnId = urlParams.get('atomTxnId');
        const referenceNo = urlParams.get('referenceNo');

        if (paymentStatus) {
            this.handlePaymentRedirect(paymentStatus, txnId, atomTxnId, referenceNo);
            return; // Don't continue with normal mount if handling payment redirect
        }

        await this.getFeeInstallments();
        await this.getAdmissionSettingsInfo();
        this.props.getBranchesLatest();
        this.props.getBoardsData(true);
        await this.getAdmissionTypeDropdown();
        await this.getAcademicSessions();

        const applicationId = await localStorage.getItem('applicationId');
        const enquiryId = await localStorage.getItem('enquiryId');

        if (enquiryId) {
            await this.getEnquiryInfo(enquiryId);
        }

        if (applicationId) {
            await this.getAdmissionInfo(applicationId);
            // Check fee payment status after loading application data
            // await this.checkEnrollmentFeePaidStatus();
        }

        // Check if returning from preview with confirmation
        // Move this after data loading is complete
        if (this.props.location?.state?.shouldConfirm) {
            // Auto-trigger the confirmation process after data is loaded
            setTimeout(() => {
                //this.onConfrimEnrollment();
                //  this.checkEnrollmentFeePaidStatus();

            }, 500);
        }
        // No longer checking fee status here as it will be called in the callbacks where data is guaranteed to be loaded
    }

    componentDidUpdate(prevProps, prevState) {
        // Debug logging for classes and boards
        if (prevState.classes !== this.state.classes) {
            console.log('Classes updated:', this.state.classes);
        }
        if (prevState.boards !== this.state.boards) {
            console.log('Boards updated:', this.state.boards);
        }

        // Auto-populate branch and board when props are received
        if (prevProps.boards !== this.props.boards && this.props.boards?.length > 0) {
            console.log('Props boards received:', this.props.boards);

            // If enrollment has branch set, populate boards automatically
            if (this.state.enrollment?.branch && !this.state.boards?.length) {
                this.onChangeBranch(this.state.enrollment.branch, true);
            }
        }



    }

    getFeeInstallments = async () => {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/feeInstallments?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ paymentTerms: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    };

    getAdmissionSettingsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ admissionSettingsInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    };

    getAcademicSessions = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/academic-years/filter`;
        try {
            const res = await this.service.get(url, {}, true);
            if (res?.res?.status && res.status) {
                this.setState({ academicSessions: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    };



    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admission => ({
                    label: admission.categoryName,
                    value: admission._id
                }));

                // If enrollment already has an academicCategory but no admissionCategoryName,
                // populate the category name from the fetched data
                const currentAcademicCategory = this.state.enrollment?.academicCategory;
                if (currentAcademicCategory && !this.state.enrollment?.admissionCategoryName) {
                    const matchingCategory = result.find(cat => cat.value === currentAcademicCategory);
                    if (matchingCategory) {
                        this.setState(prevState => ({
                            academicCategory: result,
                            isLoading: false,
                            enrollment: {
                                ...prevState.enrollment,
                                admissionCategoryName: matchingCategory.label
                            }
                        }));
                    } else {
                        this.setState({ academicCategory: result, isLoading: false });
                    }
                } else {
                    this.setState({ academicCategory: result, isLoading: false });
                }
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    // Generate applicationId for 2-stage admission flow when enrollment form loads without applicationId
    generateApplicationIdForEnrollment = async (admissionRecord) => {
        try {
            // Check if this is a 2-stage flow (only enquiry and enrollment enabled)
            const { application, examTest, registration, enrollment } = this.state.admissionSettingsInfo || {};
            const isTwoStageFlow = !application && !examTest && !registration && enrollment;

            // Only generate if:
            // 1. It's a 2-stage flow
            // 2. No applicationId exists yet
            // 3. We have a valid admission record
            if (!isTwoStageFlow || admissionRecord?.applicationId || !admissionRecord?._id) {
                console.log('⏭️ Skipping applicationId generation:', {
                    isTwoStageFlow,
                    hasApplicationId: !!admissionRecord?.applicationId,
                    hasRecordId: !!admissionRecord?._id
                });
                return admissionRecord; // Return unchanged
            }

            console.log('🔄 Generating applicationId for 2-stage enrollment flow...');
            this.setState({ isLoading: true });

            const url = `${baseUrlAdmin}/admissions/generate-application-id`;
            const payload = {
                _id: admissionRecord._id,
                orgId: admissionRecord.orgId,
                academicSession: admissionRecord.academicSession,
                board: admissionRecord.board,
                grade: admissionRecord.grade
            };

            const res = await this.service.post(url, payload, true);

            if (res && res.status && res.res.status) {
                const generatedApplicationId = res.res.data?.applicationId;
                console.log('✅ ApplicationId generated successfully:', generatedApplicationId);

                // Update the admission record with the new applicationId
                const updatedRecord = { ...admissionRecord, applicationId: generatedApplicationId };

                this.setState({
                    isLoading: false,
                    enrollment: updatedRecord
                });

                this.toast.show({
                    severity: 'success',
                    summary: 'Application ID Generated',
                    detail: `Application ID: ${generatedApplicationId}`,
                    life: 3000
                });

                return updatedRecord;
            } else {
                console.error('❌ Failed to generate applicationId:', res?.errMessage);
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: res?.errMessage || 'Failed to generate Application ID',
                    life: 3000
                });
                return admissionRecord;
            }
        } catch (error) {
            console.error('❌ Error generating applicationId:', error);
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to generate Application ID',
                life: 3000
            });
            return admissionRecord;
        }
    };

    getEnquiryInfo = async (enquiryId) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/admissions/form?id=${enquiryId}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res.data.admissionRecords.length) {
                        // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                        let enquiryRecord = res.res.data.admissionRecords[0];

                        // Check if it's a nested array and extract the actual record
                        if (Array.isArray(enquiryRecord) && enquiryRecord.length > 0) {
                            enquiryRecord = enquiryRecord[0];
                            console.log('📦 getEnquiryInfo: Extracted from nested array structure');
                        }

                        // Initialize parents data
                        let initialParents = [
                            {
                                parentType: '',
                                parentName: '',
                                qualification: '',
                                profession: '',
                                countryCode: '',
                                parentContact: '',
                                parentEmailId: '',
                            }
                        ];

                        // Initialize siblings data
                        let initialSiblings = [
                            { name: "", gender: "", classStudying: "", schoolStudying: "" }
                        ];

                        // Check if we have parents data
                        if (enquiryRecord?.parents?.length > 0) {
                            initialParents = enquiryRecord.parents;
                        }

                        // Check if we have siblings data
                        if (enquiryRecord?.siblings?.length > 0) {
                            initialSiblings = enquiryRecord.siblings;
                        }

                        console.log('Enquiry data loaded:', enquiryRecord);
                        console.log('Initial parents:', initialParents);
                        console.log('Initial siblings:', initialSiblings);

                        this.setState(
                            {
                                isLoading: false,
                                enrollment: enquiryRecord,
                                parents: initialParents,
                                siblings: initialSiblings
                            },
                            async () => {
                                console.log('State after setting enrollment data:', this.state);
                                this.onChangeBranch(this.state?.enrollment?.branch, true);
                                this.onChangeBoard(this.state?.enrollment?.board, true);
                                await this.handlePayFee(false);

                                // Check enrollment fee status if stage is Enrollment
                                if (enquiryRecord?.stage === 'Enrollment') {
                                    this.checkEnrollmentFeePaidStatus();
                                }

                                // Generate applicationId if needed for 2-stage flow
                                await this.generateApplicationIdForEnrollment(enquiryRecord);

                                localStorage.removeItem('enquiryId');
                            }
                        );
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                console.log(e);
            });
    };

    getAdmissionInfo = async (applicationId) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/admissions/form?id=${applicationId}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res.data.admissionRecords.length) {
                        // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                        let admissionRecord = res.res.data.admissionRecords[0];

                        // Check if it's a nested array and extract the actual record
                        if (Array.isArray(admissionRecord) && admissionRecord.length > 0) {
                            admissionRecord = admissionRecord[0];
                            console.log('📦 getAdmissionInfo: Extracted from nested array structure');
                        }

                        // Initialize parents data
                        let initialParents = [
                            {
                                parentType: '',
                                parentName: '',
                                qualification: '',
                                profession: '',
                                countryCode: '',
                                parentContact: '',
                                parentEmailId: '',
                            }
                        ];

                        // Initialize siblings data
                        let initialSiblings = [
                            { name: "", gender: "", classStudying: "", schoolStudying: "" }
                        ];

                        // Check if we have parents data
                        if (admissionRecord?.parents?.length > 0) {
                            initialParents = admissionRecord.parents;
                        }

                        // Check if we have siblings data
                        if (admissionRecord?.siblings?.length > 0) {
                            initialSiblings = admissionRecord.siblings;
                        }

                        console.log('Admission data loaded:', admissionRecord);
                        console.log('Initial parents:', initialParents);
                        console.log('Initial siblings:', initialSiblings);

                        // Load districts for edit mode if state is selected
                        let districtsForState = [];
                        if (admissionRecord?.state) {
                            const selectedState = admissionRecord.state;
                            const selectedStateDistricts = districts[selectedState] || [];

                            // Transform districts to dropdown format with {label, value}
                            let transformedDistricts = selectedStateDistricts.map(district => ({
                                label: district,
                                value: district
                            }));

                            // If no districts found for the selected state, add "Other" option
                            if (transformedDistricts.length === 0) {
                                transformedDistricts = [{ label: 'Other', value: 'Other' }];
                            }

                            districtsForState = transformedDistricts;
                        }

                        // Set category name if missing
                        if (admissionRecord?.academicCategory && !admissionRecord?.admissionCategoryName) {
                            const matchingCategory = this.state.academicCategory.find(
                                cat => cat.value === admissionRecord.academicCategory
                            );
                            if (matchingCategory) {
                                admissionRecord.admissionCategoryName = matchingCategory.label;
                            }
                        }

                        // Extract registrationDate from nested structure if not at root level
                        if (!admissionRecord.registrationDate && admissionRecord?.registration?.registrationDate) {
                            admissionRecord.registrationDate = admissionRecord.registration.registrationDate;
                        }
                        // Similarly for enrollmentDate
                        if (!admissionRecord.enrollmentDate && admissionRecord?.enrollment?.enrollmentDate) {
                            admissionRecord.enrollmentDate = admissionRecord.enrollment.enrollmentDate;
                        }

                        // Extract and validate DOB
                        let dobValue = admissionRecord.dob;
                        if (dobValue) {
                            const dobDate = new Date(dobValue);
                            // Check if the date is invalid or epoch (1/1/1970)
                            if (isNaN(dobDate.getTime()) || dobDate.getFullYear() <= 1970) {
                                // Try to get from other sources
                                if (admissionRecord?.enquiry?.dob) {
                                    const enquiryDob = new Date(admissionRecord.enquiry.dob);
                                    if (!isNaN(enquiryDob.getTime()) && enquiryDob.getFullYear() > 1970) {
                                        dobValue = admissionRecord.enquiry.dob;
                                    }
                                } else if (admissionRecord?.application?.dob) {
                                    const appDob = new Date(admissionRecord.application.dob);
                                    if (!isNaN(appDob.getTime()) && appDob.getFullYear() > 1970) {
                                        dobValue = admissionRecord.application.dob;
                                    }
                                }
                            }
                        }

                        this.setState(
                            {
                                isLoading: false,
                                enrollment: { ...admissionRecord, dob: dobValue },
                                dob: dobValue ? new Date(dobValue) : null,
                                parents: initialParents,
                                siblings: initialSiblings,
                                viewEnrollment: true,
                                parentDetails: admissionRecord?.registration?.parentDetails,
                                selectedFeeStructure: admissionRecord?.registration?.feeStructure ?? null,
                                isOptedForTransport: admissionRecord?.registration?.transport ?? false,
                                requestedStop: admissionRecord?.registration?.requestedStop ?? null,
                                canShowTransport: admissionRecord?.registration?.transport ?? false,
                                cityOrDist: districtsForState.length > 0 ? districtsForState : this.state.cityOrDist,
                            },
                            async () => {
                                console.log('State after setting admission data:', this.state);
                                await this.handlePayFee(false);
                                this.state.isOptedForTransport && (await this.getTransportInfo());
                                this.state.isOptedForTransport && (await this.getTransportFeeStructure());
                                this.state.isOptedForTransport && (await this.getSelectedFeeStructure(this.state.selectedFeeStructure, false));
                                await this.getFeeStructures();

                                // Update branch and board dropdowns without clearing existing selections
                                if (admissionRecord?.branch) {
                                    this.onChangeBranch(admissionRecord.branch, true);
                                }
                                if (admissionRecord?.board) {
                                    this.onChangeBoard(admissionRecord.board, true);
                                }

                                // Check enrollment fee status after all data is loaded
                                this.checkEnrollmentFeePaidStatus();

                                // Generate applicationId if needed for 2-stage flow
                                await this.generateApplicationIdForEnrollment(admissionRecord);
                            }
                        );
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                console.log(e);
            });
    };

    handlePayFee = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/application-fee/filter`;
        try {
            let payload = {
                isActive: true,
                academicYear: this.state.enrollment?.academicSession,
                orgId: this.state.enrollment?.orgId,
                board: this.state.enrollment?.board,
                grade: this.state.enrollment?.grade,
                admissionStep: 'Enrollment'
            };
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                // Filter payment modes here to ensure they're available before any dialog might open
                let paymentMode = paymentModes.filter((e) => e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' && e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1');
                const shouldShowPayButton = res?.res?.data && Object.keys(res?.res?.data).length ? true : false;

                this.setState({
                    feePayInfo: res?.res?.data,
                    isShowPayFeeButton: shouldShowPayButton,
                    paymentModes: paymentMode,
                    isLoading: false
                }, () => {
                    // Check fee paid status first, then decide whether to open dialog
                    this.onCheckFeePaidInfo(false);
                    // Do NOT auto-open dialog - let the user click Pay Fee button manually
                    // The dialog will only open when user explicitly clicks the Pay Fee button
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    // Check if enrollment fee is paid and show payment dialog if not
    checkEnrollmentFeePaidStatus = async () => {
        try {
            // First check if we have an enrollment ID
            if (this.state?.enrollment?._id) {
                const enrollmentId = this.state.enrollment._id;

                // Check fee payment status for existing enrollment
                const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${enrollmentId}`;
                const res = await this.service.get(url, true);

                if (res && res.status && res.res.status) {
                    const receiptInfo = res.res.data;
                    const isFeePaid = receiptInfo?.isEnrollmentFeePaid || false;

                    // Prepare payment modes
                    let filteredPaymentModes = paymentModes.filter((e) =>
                        e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' &&
                        e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1'
                    );

                    this.setState({
                        isEnrollmentFeePaid: isFeePaid,
                        paymentModes: filteredPaymentModes // Ensure payment modes are set
                    }, () => {
                        // If fee is not paid and we have fee configuration, show payment dialog
                        if (!isFeePaid && this.state.isShowPayFeeButton && this.state?.enrollment?.applicationId) {
                            this.setState({ isOpenPayFeeDailog: true });
                        }
                    });
                } else {
                    // If we can't get fee status, check if fee is required
                    await this.handlePayFee();  // This sets isShowPayFeeButton
                }
            } else {
                // For new enrollments, check if fee is required first
                await this.handlePayFee();  // This sets isShowPayFeeButton
            }
        } catch (error) {
            console.error('Error checking enrollment fee status:', error);

            // Show error with safe toast
            this.showToast({
                severity: 'error',
                summary: 'Error',
                detail: 'Error checking fee status. Please try again.',
                life: 3000
            });

            // On error, check if fee is required and show dialog accordingly
            await this.handlePayFee();
        }
    };

    openDailogPayAppFee = () => {
        // Ensure payment modes are set before opening dialog
        // if (this.state?.enrollment?.applicationId && this.state.paymentModes) {
        if (this.state.paymentModes) {
            this.setState({ isOpenPayFeeDailog: true });
        } else if (this.state?.enrollment?.applicationId) {
            // If payment modes aren't set yet, set them now
            let filteredPaymentModes = paymentModes.filter((e) =>
                e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' &&
                e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1'
            );
            this.setState({
                paymentModes: filteredPaymentModes,
                isOpenPayFeeDailog: true
            });
        }
    };

    onHandleCancelPayFee = () => {
        this.setState({
            isOpenPayFeeDailog: false,
            payFeeFormData: {},
            transctionId: null
        });
    };


    // ////////////PG SDK or Script loading////////
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    /**
     * Handle NTT Data payment initiation for enrollment
     */
    handleNTTDataPayment = () => {
        const { payFeeFormData, enrollment, feePayInfo } = this.state;

        const paymentData = {
            amount: this.state.partialPayment
                ? payFeeFormData?.amountPaying
                : (feePayInfo?.amount || payFeeFormData?.dueAmount),
            studentId: enrollment?._id,
            installmentId: payFeeFormData?.installmentId,
            feeFor: 'Admissions',
            feeType: 'Enrollment',
            studentName: enrollment?.firstName && enrollment?.lastName
                ? `${enrollment.firstName} ${enrollment.lastName}`.trim()
                : enrollment?.firstName || 'Student',
            studentEmail: enrollment?.emailId || enrollment?.parentEmailId || 'student@classet.com',
            studentPhone: enrollment?.parentContact || enrollment?.contactNo || '9999999999',
            branchId: enrollment?.branch,
            boardId: enrollment?.board,
            classId: enrollment?.grade,
            sectionId: enrollment?.section,
            orgId: localStorage.getItem('orgId'),
            referenceNo: enrollment?.referenceNo

        };

        console.log('Initiating NTT Data payment for enrollment with data:', paymentData);

        // Save enrollment state to sessionStorage before payment redirect
        const enrollmentStateToSave = {
            enrollment: enrollment,
            parents: this.state.parents, // Save parent details
            siblings: this.state.siblings, // Save sibling details
            feePayInfo: feePayInfo,
            branchId: this.state.branchId,
            boardId: this.state.boardId,
            classId: this.state.classId,
            boards: this.state.boards,
            classes: this.state.classes,
            timestamp: Date.now()
        };
        sessionStorage.setItem('pendingEnrollmentPayment', JSON.stringify(enrollmentStateToSave));
        sessionStorage.setItem('enrollmentAdmissionId', enrollment?._id);
        sessionStorage.setItem('enrollmentReferenceNo', enrollment?.referenceNo);

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    /**
     * Handle successful NTT payment for enrollment
     */
    onNTTPaymentSuccess = (paymentResult) => {
        console.log('NTT Payment successful for enrollment:', paymentResult);

        this.setState({
            transctionId: paymentResult.transactionId || paymentResult.payment_id,
            showNTTPayment: false,
            nttPaymentData: null
        }, () => {
            this.OnPayFee();
        });
    };

    /**
     * Handle NTT payment error for enrollment
     */
    onNTTPaymentError = (error) => {
        console.error('NTT Payment error for enrollment:', error);

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Error',
                detail: error.message || 'Payment failed. Please try again.',
                life: 5000
            });
        }
    };

    /**
     * Handle NTT payment cancellation for enrollment
     */
    onNTTPaymentCancel = () => {
        console.log('NTT Payment cancelled for enrollment');

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'warn',
                summary: 'Payment Cancelled',
                detail: 'Payment was cancelled by user',
                life: 3000
            });
        }
    };

    /**
     * Handle payment redirect after gateway returns (for Enrollment)
     */
    handlePaymentRedirect = async (status, txnId, atomTxnId, referenceNo) => {
        console.log('Enrollment payment redirect detected:', { status, txnId, atomTxnId, referenceNo });

        // Restore enrollment state from sessionStorage
        const savedState = sessionStorage.getItem('pendingEnrollmentPayment');

        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                const savedAdmissionId = sessionStorage.getItem('enrollmentAdmissionId');
                const savedReferenceNo = sessionStorage.getItem('enrollmentReferenceNo');

                // Check if saved state is not too old (30 minutes)
                if (Date.now() - parsedState.timestamp < 30 * 60 * 1000) {

                    if (status === 'success') {
                        // Payment successful
                        this.setState({
                            isLoading: true
                        });

                        // Verify payment status from backend
                        try {
                            const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                            const verifyResponse = await this.service.post(verifyUrl, {
                                txnId: txnId, // merchTxnId (order_id) - guaranteed to exist
                                atomTxnId: atomTxnId, // May not exist yet if callback hasn't arrived
                                admissionId: savedAdmissionId,
                                referenceNo: savedReferenceNo || referenceNo
                            }, true);

                            if (verifyResponse?.res?.status) {
                                // Payment verified successfully
                                const paymentData = verifyResponse.res.data;

                                console.log('📥 Enrollment Payment Verification Response:', {
                                    fullResponse: verifyResponse,
                                    paymentData: paymentData,
                                    hasReceipt: !!paymentData.receipt,
                                    receipt: paymentData.receipt,
                                    enrollmentFeePaid: paymentData.enrollmentFeePaid,
                                    transactionId: paymentData.transactionId,
                                    amount: paymentData.amount,
                                    studentName: paymentData.studentName,
                                    academicYearCode: paymentData.academicYearCode
                                });

                                // CRITICAL: Call payFee to save enrollment fee to AdmissionFee collection
                                // This creates the receipt data that will be displayed
                                try {
                                    // Get academicYear ID (not academicYearCode) - REQUIRED by backend
                                    const academicYear = parsedState.enrollment?.academicSession || localStorage.getItem('userAcademicYear');

                                    const payFeeUrl = `${baseUrlAdmin}/admissions/payFee`;
                                    const payFeePayload = {
                                        admissionId: savedAdmissionId,
                                        academicYear: academicYear, // REQUIRED - Backend expects ObjectId of academic year
                                        academicYearCode: parsedState.enrollment?.enquiry?.academicYearCode || parsedState.enrollment?.academicYearCode,
                                        admissionCategoryName: parsedState.enrollment?.enquiry?.admissionCategoryName || parsedState.enrollment?.admissionCategoryName,
                                        studentName: `${parsedState.enrollment?.firstName || ''} ${parsedState.enrollment?.lastName || ''}`.trim(),
                                        applicationNo: parsedState.enrollment?.applicationId,
                                        gradeName: parsedState.enrollment?.gradeName,
                                        stage: 'Enrollment',
                                        transctionId: paymentData.transactionId,
                                        transactionId: paymentData.transactionId,
                                        orderId: paymentData.atomTxnId || txnId,
                                        paymentMode: 'Online',
                                        FeeTypeName: 'Enrollment Fee',
                                        feeAmount: paymentData.amount,
                                        paymentType: '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' // Online payment type ID
                                    };

                                    console.log('💳 Calling payFee API with payload:', {
                                        ...payFeePayload,
                                        hasAcademicYear: !!academicYear
                                    });

                                    const payFeeResponse = await this.service.post(payFeeUrl, payFeePayload, true);

                                    console.log('📝 payFee API response:', {
                                        status: payFeeResponse?.res?.status,
                                        message: payFeeResponse?.res?.message,
                                        hasData: !!payFeeResponse?.res?.data
                                    });

                                    if (payFeeResponse?.res?.status) {
                                        console.log('✅ Enrollment fee saved successfully');

                                        // Now fetch the updated receipt data
                                        const feePaidUrl = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${savedAdmissionId}`;
                                        const feePaidResponse = await this.service.get(feePaidUrl, true);

                                        console.log('📋 feePaidInfo response:', {
                                            status: feePaidResponse?.res?.status,
                                            hasData: !!feePaidResponse?.res?.data,
                                            hasEnrollment: !!feePaidResponse?.res?.data?.enrollment,
                                            receiptNo: feePaidResponse?.res?.data?.enrollment?.receiptNo
                                        });

                                        if (feePaidResponse?.res?.status && feePaidResponse.res.data) {
                                            paymentData.receipt = feePaidResponse.res.data;
                                            console.log('✅ Updated receipt data fetched:', {
                                                hasEnrollment: !!paymentData.receipt.enrollment,
                                                enrollmentReceiptNo: paymentData.receipt.enrollment?.receiptNo,
                                                enrollmentAmount: paymentData.receipt.enrollment?.feeAmount
                                            });
                                        }
                                    } else {
                                        console.error('❌ payFee API returned unsuccessful status:', payFeeResponse);
                                    }
                                } catch (payFeeError) {
                                    console.error('❌ Error calling payFee:', {
                                        error: payFeeError,
                                        message: payFeeError?.message,
                                        response: payFeeError?.response,
                                        errMessage: payFeeError?.errMessage,
                                        statusCode: payFeeError?.response?.status,
                                        responseData: payFeeError?.response?.data
                                    });

                                    // Check for specific error about fee settings
                                    const errorMessage = payFeeError?.errMessage || payFeeError?.response?.data?.message || payFeeError?.message || '';

                                    if (errorMessage.includes('Receipt prefix') || errorMessage.includes('Fee Settings')) {
                                        // Show specific error for missing fee settings
                                        this.toast.show({
                                            severity: 'error',
                                            summary: 'Fee Settings Not Configured',
                                            detail: 'Please configure Fee Settings (Receipt Prefix) in Admin panel before collecting fees.',
                                            life: 15000,
                                            sticky: true
                                        });
                                    } else {
                                        // Show generic warning
                                        this.toast.show({
                                            severity: 'warn',
                                            summary: 'Warning: Receipt Data Incomplete',
                                            detail: `Payment successful but receipt could not be generated: ${errorMessage}. Please contact admin.`,
                                            life: 12000,
                                            sticky: true
                                        });
                                    }

                                    // If payFee failed, manually construct receipt data from what we have
                                    console.warn('⚠️ payFee failed, constructing receipt from available data');
                                    if (!paymentData.receipt || !paymentData.receipt.studentName) {
                                        paymentData.receipt = {
                                            ...paymentData.receipt,
                                            studentName: `${parsedState.enrollment?.firstName || ''} ${parsedState.enrollment?.lastName || ''}`.trim(),
                                            gradeName: parsedState.enrollment?.gradeName,
                                            academicYearCode: parsedState.enrollment?.enquiry?.academicYearCode || parsedState.enrollment?.academicYearCode,
                                            FeeTypeName: 'Enrollment Fee',
                                            paymentMode: 'Online',
                                            feeAmount: paymentData.amount,
                                            transactionId: paymentData.transactionId,
                                            receiptNo: 'PENDING' // Will be generated when payFee is called successfully later
                                        };
                                        console.log('📝 Constructed fallback receipt:', paymentData.receipt);
                                    }
                                }

                                // Restore enrollment state with all saved data
                                this.setState({
                                    enrollment: {
                                        ...parsedState.enrollment,
                                        enrollmentFeePaid: true
                                    },
                                    parents: parsedState.parents || this.state.parents,
                                    siblings: parsedState.siblings || this.state.siblings,
                                    branchId: parsedState.branchId || this.state.branchId,
                                    boardId: parsedState.boardId || this.state.boardId,
                                    classId: parsedState.classId || this.state.classId,
                                    boards: parsedState.boards || this.state.boards,
                                    classes: parsedState.classes || this.state.classes,
                                    isEnrollmentFeePaid: true,
                                    isLoading: false,
                                    receiptInfo: paymentData.receipt || null,
                                    isPaymentJustCompleted: true
                                }, () => {
                                    console.log('📄 About to show receipt. receiptInfo:', this.state.receiptInfo);

                                    // Format and show receipt using handleShowReceipt
                                    if (paymentData.receipt) {
                                        this.handleShowReceipt(true);
                                    } else {
                                        console.warn('⚠️ No receipt data from payment verification, fetching from feePaidInfo');
                                        // Fallback: try to fetch receipt from feePaidInfo endpoint
                                        this.onCheckFeePaidInfo(true);
                                    }
                                });

                                // Show success message with confirmation
                                this.toast.show({
                                    severity: 'success',
                                    summary: '✅ Payment Successful',
                                    detail: `Enrollment fee paid successfully! Transaction ID: ${paymentData.transactionId}`,
                                    life: 8000,
                                    sticky: false
                                });

                                // C+lear session storage
                                sessionStorage.removeItem('pendingEnrollmentPayment');
                                sessionStorage.removeItem('enrollmentAdmissionId');
                                sessionStorage.removeItem('enrollmentReferenceNo');

                                // Clean URL
                                window.history.replaceState({}, document.title, '/confirm-enrollment');
                            } else {
                                throw new Error(verifyResponse?.res?.message || 'Payment verification failed');
                            }
                        } catch (error) {
                            console.error('Payment verification error:', error);

                            // Restore form silently - verification may fail temporarily while callback is processing
                            this.setState({
                                enrollment: parsedState.enrollment,
                                parents: parsedState.parents || this.state.parents,
                                siblings: parsedState.siblings || this.state.siblings,
                                branchId: parsedState.branchId || this.state.branchId,
                                boardId: parsedState.boardId || this.state.boardId,
                                classId: parsedState.classId || this.state.classId,
                                boards: parsedState.boards || this.state.boards,
                                classes: parsedState.classes || this.state.classes,
                                isLoading: false
                            });

                            // Clear session storage and URL
                            sessionStorage.removeItem('pendingEnrollmentPayment');
                            sessionStorage.removeItem('enrollmentAdmissionId');
                            sessionStorage.removeItem('enrollmentReferenceNo');
                            window.history.replaceState({}, document.title, '/confirm-enrollment');
                        }
                    } else if (status === 'failure') {
                        // Payment failed
                        this.setState({
                            enrollment: parsedState.enrollment,
                            parents: parsedState.parents || this.state.parents,
                            siblings: parsedState.siblings || this.state.siblings,
                            branchId: parsedState.branchId || this.state.branchId,
                            boardId: parsedState.boardId || this.state.boardId,
                            classId: parsedState.classId || this.state.classId,
                            boards: parsedState.boards || this.state.boards,
                            classes: parsedState.classes || this.state.classes,
                            isLoading: false
                        });

                        this.toast.show({
                            severity: 'error',
                            summary: '❌ Payment Failed',
                            detail: 'Payment was not completed. Please try again.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/confirm-enrollment');
                    } else if (status === 'cancelled') {
                        // Payment cancelled
                        this.setState({
                            enrollment: parsedState.enrollment,
                            parents: parsedState.parents || this.state.parents,
                            siblings: parsedState.siblings || this.state.siblings,
                            branchId: parsedState.branchId || this.state.branchId,
                            boardId: parsedState.boardId || this.state.boardId,
                            classId: parsedState.classId || this.state.classId,
                            boards: parsedState.boards || this.state.boards,
                            classes: parsedState.classes || this.state.classes,
                            isLoading: false
                        });

                        this.toast.show({
                            severity: 'warn',
                            summary: 'Payment Cancelled',
                            detail: 'You cancelled the payment. You can retry payment anytime.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/confirm-enrollment');
                    }
                } else {
                    // Session expired
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Session Expired',
                        detail: 'Payment session expired. Please start again.',
                        life: 5000
                    });
                    sessionStorage.removeItem('pendingEnrollmentPayment');
                    sessionStorage.removeItem('enrollmentAdmissionId');
                    sessionStorage.removeItem('enrollmentReferenceNo');
                }
            } catch (error) {
                console.error('Error restoring enrollment state:', error);
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to restore enrollment data',
                    life: 5000
                });
            }
        } else {
            // No saved state - might be a direct link or manual refresh
            if (status === 'success' && referenceNo) {
                this.toast.show({
                    severity: 'info',
                    summary: 'Payment Completed',
                    detail: 'Loading your enrollment details...',
                    life: 3000
                });

                // Try to verify payment and load enrollment by referenceNo
                try {
                    const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                    const verifyResponse = await this.service.post(verifyUrl, {
                        txnId: txnId,
                        atomTxnId: atomTxnId,
                        referenceNo: referenceNo
                    }, true);

                    if (verifyResponse?.res?.status && verifyResponse.res.data?.referenceNo) {
                        // Load admission by referenceNo
                        const admissionId = sessionStorage.getItem('enrollmentAdmissionId') || localStorage.getItem('applicationId');
                        if (admissionId) {
                            await this.getAdmissionInfo(admissionId);

                            this.toast.show({
                                severity: 'success',
                                summary: '✅ Payment Confirmed',
                                detail: `Payment successful! Transaction ID: ${verifyResponse.res.data.transactionId}`,
                                life: 5000
                            });

                            // Clean URL
                            window.history.replaceState({}, document.title, '/confirm-enrollment');
                        }
                    }
                } catch (error) {
                    console.error('Error loading enrollment after payment:', error);
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Payment Completed',
                        detail: 'Payment was successful but could not load enrollment. Please refresh the page.',
                        life: 5000
                    });
                }
            }
        }
    };

    handlePayment = async () => {
        let payType = this.state.payFeeFormData?.paymentType;
        let a = this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount
        // let PGtype = 'cashfree'; // Default payment gateway type, can be changed based on user selection
        let PGtype = process.env.REACT_APP_DEFAULT_PAYMENT_GATEWAY || 'ntt_data';


        if (payType) {

            if (
                payType === '74b95cc8-9736-44a0-b2df-325595783c3b' ||
                payType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ||
                payType === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" ||
                payType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                payType === "274a4416-2454-4f3a-b741-89c67361ae1f"
            ) {
                this.OnPayFee()
            } else if (
                payType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                payType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
            ) {
                switch (PGtype) {
                    case 'ntt_data': {
                        console.log('🔄 Initiating NTT Data payment for enrollment...');
                        this.handleNTTDataPayment();
                        break;
                    }
                    case 'razorpay': {
                        const res = await this.loadRazorpayScript();
                        if (!res) {
                            alert("Failed to load Razorpay SDK. Check your internet connection.");
                            return;
                        }
                        let url = `${baseUrlAdmin}/create-order`;
                        let vurl = `${baseUrlAdmin}/verify-payment`;

                        let payload = {
                            amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying * 100 : this.state.payFeeFormData?.dueAmount * 100,
                            currency: "INR"
                        }
                        // Get order details from your backend
                        const { data: order } = await Axios.post(url, payload);

                        const options = {
                            key: "rzp_test_rJgczs9D0fmDjk", // Replace with your Razorpay key
                            amount: order.amount,
                            currency: order.currency,
                            name: "Classet",
                            description: "Purchase Description",
                            image: `https://${profilesBucket}.s3.${awsRegion}.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg`,
                            order_id: order.id,
                            handler: async (response) => {
                                const result = await Axios.post(vurl, {
                                    order_id: order.id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature,
                                });
                                this.setState({
                                    transctionId: response.razorpay_payment_id
                                }, () => {
                                    this.OnPayFee();
                                })
                            },


                            prefill: {
                                name: "Monangi Kiran",
                                email: "kiranm@classet.in",
                                contact: "7799279701",
                            },
                            theme: {
                                color: "#3399cc",
                            },
                        };

                        const paymentObject = new window.Razorpay(options);
                        console.log("RAZOR", paymentObject)
                        paymentObject.open();
                    }; break;
                    case 'cashfree': {
                        let parentContactNumer;
                        if (this.state.searchLevel === 2) {
                            parentContactNumer = this.state?.dropdownsData?.parentContactNumber[0];
                        }

                        const url = `${baseUrlAdmin}/cashfree/create-order`;
                        const payload = {
                            orgId: localStorage.getItem('orgId'),
                            academicYear: localStorage.getItem('userAcademicYear'),
                            platform: 'web',

                            order_amount: this.state.partialPayment
                                ? this.state.payFeeFormData?.amountPaying
                                : this.state.feePayInfo?.amount || 102,
                            order_currency: "INR",
                            order_id: "order_" + uuidv4(), // Generate a unique order ID using uuid
                            customer_details: {
                                customer_name: this.state?.enrollment?.firstName && this.state?.enrollment?.lastName
                                    ? `${this.state.enrollment.firstName} ${this.state.enrollment.lastName}`.trim()
                                    : `${this.state?.enrollment?.firstName || 'Student'}`,
                                customer_id: this.state?.enrollment?._id || "NA_123",
                                customer_email: this.state?.enrollment?.parentEmailId || "NA1234@gmail.com",
                                customer_phone: this.state?.enrollment?.parentContact || this.state?.enrollment?.contactNo || "4044044044",
                            },
                            order_meta: {
                                return_url: null,
                            },
                        };

                        this.setState({ isLoading: true });

                        // Try asymmetric encryption first, fallback to symmetric, then unencrypted
                        const encryptPayload = async (payload) => {
                            try {
                                // Use only asymmetric (hybrid) encryption for strong security
                                console.log('🔐 Attempting hybrid encryption for Cashfree order creation...');
                                const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                if (hybridEncrypted.hybridEncrypted) {
                                    console.log('✅ Hybrid encryption successful for order creation');
                                    return hybridEncrypted;
                                }

                                // If encryption fails, throw error instead of sending unencrypted data
                                throw new Error('Hybrid encryption failed');

                            } catch (error) {
                                console.error('❌ Payment encryption failed:', error);
                                throw new Error('Payment encryption failed. Please try again.');
                            }
                        };

                        encryptPayload(payload)
                            .then((encryptedPayload) => {
                                return this.service.post(url, encryptedPayload, true);
                            })
                            .then(async (response) => {
                                this.setState({ isLoading: false });

                                console.log('🔍 Raw Cashfree order creation response:', response);

                                // Decrypt the response if it's encrypted
                                let decryptedResponse = response;

                                // Check if response needs decryption
                                if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                    try {
                                        console.log('🔓 Decrypting Cashfree order creation response...');
                                        console.log('🔍 Response structure before decryption:', {
                                            hasRes: !!response.res,
                                            encrypted: response.res?.encrypted,
                                            hybridEncrypted: response.res?.hybridEncrypted,
                                            keys: Object.keys(response.res || {})
                                        });

                                        // Decrypt using asymmetric encryption utils
                                        const decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                        console.log('✅ Order creation response decrypted successfully');
                                        console.log('🔍 Decrypted data structure:', {
                                            hasStatus: !!decryptedData.status,
                                            hasData: !!decryptedData.data,
                                            dataKeys: Object.keys(decryptedData.data || {}),
                                            hasPaymentSessionId: !!decryptedData.data?.payment_session_id
                                        });

                                        decryptedResponse = {
                                            ...response,
                                            res: decryptedData
                                        };

                                        // Also create direct data access for backward compatibility
                                        decryptedResponse.data = decryptedData.data;
                                        decryptedResponse.status = decryptedData.status;

                                    } catch (decryptError) {
                                        console.error('❌ Error decrypting order creation response:', decryptError);
                                        console.warn('⚠️ Using original response due to decryption error');
                                        // Continue with original response as fallback
                                    }
                                } else {
                                    console.log('✅ Response is not encrypted, using as-is');
                                    // For unencrypted responses, ensure proper structure
                                    if (response.res) {
                                        decryptedResponse.data = response.res.data;
                                        decryptedResponse.status = response.res.status;
                                    }
                                }

                                console.log('🔍 Final decryptedResponse structure:', {
                                    hasStatus: !!decryptedResponse.status,
                                    hasData: !!decryptedResponse.data,
                                    hasResStatus: !!decryptedResponse.res?.status,
                                    hasResData: !!decryptedResponse.res?.data,
                                    dataKeys: Object.keys(decryptedResponse.data || {}),
                                    resDataKeys: Object.keys(decryptedResponse.res?.data || {})
                                });

                                // Check for payment_session_id in correct response structure
                                let paymentSessionId = null;
                                let foundInLocation = '';

                                // Primary locations - check decrypted response first
                                if (decryptedResponse.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.data.payment_session_id';
                                } else if (decryptedResponse.res?.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.res.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.res.data.payment_session_id';
                                } else if (decryptedResponse.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.data.paymentSessionId';
                                } else if (decryptedResponse.res?.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.res.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.res.data.paymentSessionId';
                                }

                                console.log('🔍 Payment session ID search result:', {
                                    paymentSessionId,
                                    foundInLocation,
                                    availableKeys: {
                                        decryptedResponseData: Object.keys(decryptedResponse.data || {}),
                                        decryptedResponseResData: Object.keys(decryptedResponse.res?.data || {})
                                    }
                                });

                                if (decryptedResponse.status && paymentSessionId) {
                                    console.log('✅ Found payment session ID:', paymentSessionId, 'at location:', foundInLocation);

                                    //TO CREATE ORDER -> from order, paymentSessionId generated -> payments gets completed.
                                    // Open Cashfree checkout modal
                                    const checkoutOptions = {
                                        paymentSessionId: paymentSessionId,
                                        redirectTarget: "_modal",
                                    };
                                    const initializeCashfree = async () => {
                                        const { load } = await import('@cashfreepayments/cashfree-js');
                                        // const cashfree = await load({ mode: "sandbox" }); // Use "production" for live environment
                                        const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE;
                                        const cashfree = await load({ mode: cashfreeMode });

                                        cashfree.checkout(checkoutOptions).then((result) => {
                                            if (result.error) {
                                                console.error("Payment error:", result.error);
                                            } else if (result.paymentDetails) {
                                                // console.log("===AFTER PAYMENT DETAILS===:", result);
                                                // console.log("Payment completed successfully:", result.paymentDetails);

                                                // store the payment details.
                                                sendPaymentSessionDetails()
                                                // console.log('PAYLOAD.ORDER_ID:', payload.order_id);
                                            }
                                        });
                                    };
                                    initializeCashfree();

                                    // Send and Store 
                                    const sendPaymentSessionDetails = async () => {
                                        // const isMobile = /Mobi|Android/i.test(navigator.userAgent); // Check if the user is on a mobile device
                                        const isDoneThrough = "Web-Admin"
                                        const loggedInUser = localStorage.getItem('username'); // Replace 'username' with the key used to store user info
                                        // console.log("**********Payment Details:*****************", paymentDetails);

                                        try {
                                            // Prepare the verify-and-collect payload
                                            const verifyCollectPayload = {
                                                // Order and payment details
                                                orderId: payload.order_id,
                                                paymentSessionId: paymentSessionId,
                                                paymentDetails: 'payment finished',

                                                // Organization and academic details
                                                academicYear: localStorage.getItem('userAcademicYear'),
                                                orgId: localStorage.getItem('orgId'),
                                                academicSession: localStorage.getItem('userAcademicYear'),
                                                academicYearCode: this.state.enrollment?.enquiry?.academicYearCode,
                                                admissionCategoryName: this.state.enrollment?.enquiry?.admissionCategoryName,

                                                // Student details (using enrollment state instead of application)
                                                studentName: `${this.state?.enrollment?.firstName} ${this.state?.enrollment?.lastName}`,
                                                applicationNo: this.state?.enrollment?.applicationId,
                                                admissionId: this.state?.enrollment?._id,
                                                gradeName: this.state.enrollment?.gradeName,

                                                // Fee details for Enrollment stage
                                                stage: 'Enrollment',
                                                paymentMode: this.state.paymentModes?.find((el) => el.value == this.state.payFeeFormData?.paymentType)?.label || 'Online Payment',
                                                paymentType: this.state.payFeeFormData?.paymentType || '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54',
                                                feeTypeName: this.state.feePayInfo?.feeName,
                                                FeeTypeName: this.state.feePayInfo?.feeName, // Ensure both versions are included
                                                feeAmount: Number(this.state.feePayInfo?.amount),

                                                // Contact information (using enrollment data)
                                                branchId: this.state?.enrollment?.branch,
                                                boardId: this.state?.enrollment?.board,
                                                classId: this.state?.enrollment?.grade,
                                                sectionId: this.state?.enrollment?.sectionId,

                                                studentId: this.state?.enrollment?._id,
                                                enrollmentNo: 'NA', // Not applicable for enrollment stage
                                                parentContactNumber: this.state?.enrollment?.parentContact || this.state?.enrollment?.contactNo,

                                                // Metadata
                                                isDoneThrough: isDoneThrough,
                                                loggedInUser: loggedInUser,

                                                // Optional remarks
                                                remarks: this.state.payFeeFormData?.remarks || ''
                                            };

                                            // Encrypt verify-and-collect payload with asymmetric encryption only
                                            const encryptVerifyPayload = async (payload) => {
                                                try {
                                                    // Use only asymmetric (hybrid) encryption for strong security
                                                    console.log('🔐 Attempting hybrid encryption for payment verification...');
                                                    const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                                    if (hybridEncrypted.hybridEncrypted) {
                                                        console.log('✅ Hybrid encryption successful for verify-and-collect');
                                                        return hybridEncrypted;
                                                    }

                                                    // If encryption fails, throw error instead of sending unencrypted data
                                                    throw new Error('Hybrid encryption failed for verify-and-collect');

                                                } catch (error) {
                                                    console.error('❌ Payment verification encryption failed:', error);
                                                    throw new Error('Payment verification encryption failed. Please try again.');
                                                }
                                            };

                                            const encryptedVerifyPayload = await encryptVerifyPayload(verifyCollectPayload);
                                            const response = await this.service.post(`${baseUrlAdmin}/cashfree/verifyAndCollectAdmissionFee`, encryptedVerifyPayload, true);

                                            // Decrypt the response if it's encrypted (asymmetric only)
                                            let decryptedVerifyResponse = response;

                                            if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                                try {
                                                    console.log('🔓 Decrypting verify-and-collect response with asymmetric encryption...');

                                                    // Use only asymmetric decryption for strong security
                                                    let decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                                    decryptedVerifyResponse = {
                                                        ...response,
                                                        res: decryptedData
                                                    };

                                                    console.log('✅ Verify-and-collect response decrypted successfully with RSA + AES');
                                                } catch (decryptError) {
                                                    console.error('❌ Error decrypting verify-and-collect response:', decryptError);
                                                    // Continue with original response as fallback
                                                    console.warn('⚠️ Using original response due to decryption error');
                                                }
                                            }

                                            if (decryptedVerifyResponse?.res?.res?.data) {
                                                // Payment successful - handle receipt generation
                                                console.log(decryptedVerifyResponse?.res)
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.transactionId);
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.res?.transactionId);


                                                const receiptData = decryptedVerifyResponse.res.res.data;
                                                const paymentDetails = decryptedVerifyResponse.res.res.paymentDetails;
                                                console.log("Receipt Data:", receiptData);
                                                // console.log("transactionId:", paymentDetails.transactionId);

                                                // Attach transactionId from decryptedVerifyResponse?.res to receiptData
                                                if (decryptedVerifyResponse?.res?.res?.transactionId) {
                                                    receiptData.transactionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId;
                                                    receiptData.transctionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId; // Also set the misspelled version for compatibility
                                                }

                                                // Set transaction ID from Cashfree payment details or response
                                                const transactionId = decryptedVerifyResponse?.res?.res?.transactionId || paymentDetails?.cf_payment_id || 'N/A';


                                                // Set transaction ID from Cashfree payment details
                                                if (paymentDetails) {
                                                    this.setState({
                                                        // transctionId: 'fsadjfl',
                                                        transctionId: transactionId,
                                                    });
                                                }

                                                // Show success message
                                                this.toast.show({
                                                    severity: 'success',
                                                    summary: 'Payment Successful',
                                                    detail: 'Payment completed successfully. Receipt generated.',
                                                    life: 3000
                                                });

                                                // Set receipt data and show receipt dialog
                                                this.setState({
                                                    isEnableReceipt: true,
                                                    receiptData: receiptData,
                                                    openCreateFeeDialog: false,
                                                    isLoading: false,
                                                    isOpenPayFeeDailog: false, // Add this line to close the Pay Fee dialog

                                                    // Clear form data
                                                    payFeeFormData: {},
                                                    transactionDate: null,
                                                    chequeIssuedTo: '',
                                                    chequeNo: '',
                                                    chequeDate: new Date(),
                                                    bankName: '',
                                                    bankBranchName: '',
                                                    destinationBank: '',
                                                    transctionId: '',
                                                    approvalCode: '',
                                                    rrNumber: '',
                                                    userBankName: '',
                                                    cardNo: ''
                                                });

                                                // Refresh the term-based data to show updated payment status
                                                // this.getTermBasedData();
                                                this.onCheckFeePaidInfo(true);

                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: decryptedVerifyResponse?.res?.errMessage || 'Failed to verify payment details - receipts',
                                                    life: 3000,
                                                });
                                            }

                                        } catch (error) {
                                            console.error("Error sending payment session details:", error);

                                            // Check if it's an encryption error
                                            if (error.message && error.message.includes('encrypt')) {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Encryption Error',
                                                    detail: 'Failed to encrypt payment verification data',
                                                    life: 3000,
                                                });
                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: 'An error occurred while sending payment session details',
                                                    life: 3000,
                                                });
                                            }
                                        }
                                    };

                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: decryptedResponse.errMessage || 'Failed to create order (or) Cashfree subMerchantId not found for the organization',
                                        life: 3000,
                                    });
                                }
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });

                                // Check if it's an encryption error
                                if (error.message && error.message.includes('encrypt')) {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Encryption Error',
                                        detail: 'Failed to encrypt request data',
                                        life: 3000,
                                    });
                                    console.error("Encryption error:", error);
                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'An error occurred while creating order',
                                        life: 3000,
                                    });
                                    console.error("Error in Cashfree order creation:", error);
                                }
                            });
                    }; break;
                }
            }
        } else {
            this.toast.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Fill Payment Type And Amount', life: 3000 });

        }
    };
    OnPayFee = () => {
        const formStatus = isFormValid(createFields, this.payformFields.formValidations, trimObj(this.state.payFeeFormData));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations
            });
            isCompleteFormValid = false;
        }

        let academicYear = localStorage.getItem('userAcademicYear');
        let data = this.state.payFeeFormData;
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/admissions/payFee`;
        let paymentMode = this.state.paymentModes.find((el) => el.value == data?.paymentType)?.label;
        data.paymentMode = paymentMode;
        data.FeeTypeName = this.state.feePayInfo?.feeName;
        data.transctionId = this.state?.transctionId;
        data.feeAmount = Number(this.state.feePayInfo?.amount);
        if (
            data?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
            data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
            data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' ||
            data?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
        ) {
            if (!data?.transctionId) {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Please enter transaction id.', detail: 'Please enter transaction id.', life: 3000 });
                return;
            }
        } else {
            data.transctionId = null;
        }
        let payload = { ...data };
        if (this.state?.enrollment?._id) {
            payload.academicYearCode = this.state.enrollment?.enquiry?.academicYearCode;
            payload.admissionCategoryName = this.state.enrollment?.enquiry?.admissionCategoryName;
            payload.studentName = `${this.state?.enrollment?.firstName} ${this.state?.enrollment?.lastName}`;
            payload.applicationNo = this.state?.enrollment?.applicationId;
            payload.admissionId = this.state?.enrollment?._id;
            payload.academicYear = this.state?.enrollment?.academicSession;
            payload.gradeName = this.state.enrollment?.gradeName;
            payload.stage = 'Enrollment';
        }
        if (isCompleteFormValid) {
            this.service
                .post(url, payload, true)
                .then((res) => {
                    if (res && res.status && res.res.status) {
                        if (res.res.data) {
                            this.setState(
                                {
                                    isOpenPayFeeDailog: false,
                                    isLoading: false,
                                    payFeeFormData: {},
                                    transctionId: null
                                },
                                () => {
                                    this.onCheckFeePaidInfo(true);
                                }
                            );
                            this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                        } else {
                            this.setState({
                                isLoading: false
                            });
                            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res?.errMessage, life: 3000 });
                        }
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res?.errMessage, life: 3000 });
                    }
                })
                .catch((e) => {
                    this.setState({
                        isLoading: false
                    });
                });
        } else {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Please fill all the required fields.', detail: 'Please fill all the required fields.', life: 3000 });
        }
    };
    onCheckFeePaidInfo = async (isContinue) => {
        this.setState({
            isLoading: true
        });
        const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${this.state.enrollment?._id}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            receiptInfo: res?.res?.data
                        },
                        () => this.handleShowReceipt(isContinue)
                    );
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    handleShowReceipt = (isContinue) => {
        const { receiptInfo } = this.state;

        console.log('📄 handleShowReceipt called:', {
            isContinue,
            receiptInfo,
            hasEnrollment: !!receiptInfo?.enrollment,
            hasReceiptNo: !!receiptInfo?.receiptNo
        });

        if (!isContinue) {
            this.setState({
                isEnrollmentFeePaid: receiptInfo?.isEnrollmentFeePaid || false
            });
        } else {
            if (!receiptInfo) {
                console.error('❌ receiptInfo is null or undefined, cannot show receipt');
                return;
            }



            const stageData = receiptInfo?.enrollment || receiptInfo;

            // Extract date - handle both ISO string and MongoDB $date object
            let receiptDate = stageData?.date || receiptInfo?.date;
            if (receiptDate && receiptDate.$date) {
                receiptDate = receiptDate.$date; // Extract from MongoDB format
            }

            let receiptData = {
                receiptName: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.label || 'Enrollment Fee',
                receiptNo: stageData?.receiptNo || receiptInfo?.receiptNo,
                receiptDate: receiptDate,
                studentName: stageData?.studentName || receiptInfo?.studentName || `${this.state.enrollment?.firstName || ''} ${this.state.enrollment?.lastName || ''}`.trim(),
                academicYear: stageData?.academicYearCode || receiptInfo?.academicYearCode || this.state.enrollment?.academicSession,
                className: stageData?.gradeName || receiptInfo?.gradeName || this.state.enrollment?.gradeName,
                paymentMode: stageData?.paymentMode || receiptInfo?.paymentMode || 'Online',
                // CRITICAL: Use transactionId (actual payment gateway ID), NOT orderId
                transactionId: stageData?.transactionId || stageData?.transctionId || receiptInfo?.transactionId || this.state.transctionId,

                feePaidDetails: [
                    {
                        feeType: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.feeName || 'Enrollment Fee',
                        amountPaying: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0),
                        fineAmtPaying: 0,
                        gstPaidNow: 0
                    }
                ],
                amountPaid: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0)
            };

            console.log('📄 Enrollment Receipt Data:', {
                stageData: stageData,
                receiptDate: receiptData.receiptDate,
                transactionId: receiptData.transactionId,
                amountPaid: receiptData.amountPaid,
                orderId: stageData?.orderId,
                source: receiptInfo?.enrollment ? 'AdmissionFee document (nested)' : 'Payment verification (flat)'
            });

            this.setState({
                isShowReceipt: true,
                receiptInfo: receiptData,
                receiptData: receiptData, // FeeReceipt component expects receiptData prop
                isEnrollmentFeePaid: receiptInfo?.isEnrollmentFeePaid || false,
                isPaymentJustCompleted: false // Reset the flag after showing receipt
            });
        }
        if (!this.state.isShowPayFeeButton) {
            this.setState({
                isEnrollmentFeePaid: true
            });
        }
    };
    getTransportInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/transportInfo?academicYear=${academicYear}`;
        let payload = {};
        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res?.data?.routesList?.length) {
                        this.setState({
                            isLoading: false,
                            routesList: res.res.data.routesList
                        });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                console.log(e);
            });
    };

    onConfrimEnrollment = () => {
        this.setState({
            isLoading: true
        });



        // Safety check for enrollment data
        if (!this.state.enrollment || !this.state.enrollment._id) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Missing Enrollment Data',
                detail: 'Enrollment data is not loaded. Please try again.',
                life: 3000
            });
            return;
        }

        // Comprehensive validation of all required fields before confirmation
        const missingFields = this.validateRequiredFields();

        if (missingFields.length > 0) {
            this.setState({ isLoading: false });

            // Show detailed error message with first 5 missing fields
            const fieldsToShow = missingFields.slice(0, 5);
            const remainingCount = missingFields.length - fieldsToShow.length;
            const detailMessage = remainingCount > 0
                ? `${fieldsToShow.join(', ')} and ${remainingCount} more field(s)`
                : fieldsToShow.join(', ');

            this.toast.show({
                severity: 'error',
                summary: 'Cannot Confirm Enrollment - Required Fields Missing',
                detail: `Please fill the following required fields: ${detailMessage}`,
                life: 5000
            });

            console.log('Missing required fields:', missingFields);
            return;
        }

        // Validate transport required fields
        if (this.state.enrollment?.transportRequired && (!this.state.enrollment?.requestedStop || this.state.enrollment?.requestedStop?.trim() === "")) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Requested Stop Required',
                detail: 'Please enter the requested stop when transport is required',
                life: 3000
            });
            return;
        }



        const { enrollment } = this.state;
        console.log('✅final enrolling enrollment data: ', enrollment);



        let payload = {



            admissionId: enrollment?._id,

            // Academic Information
            academicYear: enrollment?.academicSession,
            academicYearCode: enrollment?.enquiry?.academicYearCode || enrollment?.academicYearCode,
            academicCategory: enrollment?.enquiry?.academicCategory || enrollment?.academicCategory,
            categoryName: enrollment?.enquiry?.admissionCategoryName || enrollment?.admissionCategoryName,

            // Branch Information
            branchId: enrollment?.branch,
            branchName: enrollment?.branchName,

            // Board Information
            boardId: enrollment?.board,
            board: enrollment?.boardName,

            // Grade/Class Information
            gradeId: enrollment?.grade,
            grade: enrollment?.gradeName,
            groupId: enrollment?.groupId,
            group: 'NO_GROUP',

            // Student Personal Information
            firstName: enrollment?.firstName,
            middleName: enrollment?.middleName,
            lastName: enrollment?.lastName,
            dateOfBirth: enrollment?.dob,
            gender: enrollment?.gender,

            // Contact Information
            phone_number: enrollment?.contactNo,
            email: enrollment?.emailId,
            stdCountryCode: enrollment?.stdCountryCode,
            stdContactNo: enrollment?.stdContactNo,
            stdEmailId: enrollment?.stdEmailId,

            // Identity Information
            aadharNo: enrollment?.aadharNo || enrollment?.idDetails,
            govtIdType: enrollment?.govtIdType,
            idDetails: enrollment?.idDetails,
            nationality: enrollment?.nationality,

            // Personal Details
            religion: enrollment?.registration?.religion || enrollment?.religion,
            caste: enrollment?.registration?.caste || enrollment?.caste,
            motherTongue: enrollment?.registration?.motherTongue || enrollment?.motherTongue,
            currentLocation: enrollment?.currentLocation,
            identificationMarks: enrollment?.identificationMarks,
            bloodGroup: enrollment?.bloodGroup,

            // Previous School Information
            previousSchool: enrollment?.previousSchool,
            previousBoard: enrollment?.previousBoard,
            previousGrade: enrollment?.previousGrade,

            // Address Information
            addressLine: enrollment?.registration?.addressLine || enrollment?.addressLine,
            houseNum: enrollment?.registration?.houseNum || enrollment?.houseNum,
            streetOrVillage: enrollment?.registration?.streetOrVillage || enrollment?.streetOrVillage,
            mandal: enrollment?.registration?.mandal || enrollment?.mandal,
            cityOrDist: enrollment?.registration?.cityOrDist || enrollment?.cityOrDist,
            state: enrollment?.registration?.state || enrollment?.state,
            pinCode: enrollment?.registration?.pinCode || enrollment?.pinCode,
            area: enrollment?.area,

            // Parent and Family Information
            parentDetails: enrollment?.registration?.parentDetails || this.state.parents,
            siblings: enrollment?.registration?.siblings || this.state.siblings,
            contactPersonName: enrollment?.parentName || this.state.parents[0]?.parentName || '',
            parentContactNo: enrollment?.parentContact || this.state.parents[0]?.parentContact || '',

            // Transport Information
            transportRequired: enrollment?.transportRequired,
            requestedStop: enrollment?.requestedStop,

            // Academic History
            prevAcademicDetails: enrollment?.registration?.prevAcademicDetails || enrollment?.prevAcademicDetails,

            // Admission Information
            admissionTest: enrollment?.admissionTest,

            // Admission Dates and Reference Numbers
            admissionDate: enrollment?.enrollmentDate || enrollment?.enrollment?.enrollmentDate || new Date(),
            registrationDate: enrollment?.registrationDate || enrollment?.registration?.registrationDate,
            admissionRefNo: enrollment?.referenceNo,
            applicationNo: enrollment?.applicationId,

            enrollmentAdmDate: enrollment?.enrollmentDate,
            //   registrationDate : enrollment?.registrationDate,

            // Counsellor and Referral Information
            counsellorsName: enrollment?.counsellorsName || enrollment?.enquiry?.counsellorsName,
            knowAboutUs: enrollment?.knowAboutUs || enrollment?.enquiry?.knowAboutUs,
            assignCounsellor: enrollment?.assignCounsellor || enrollment?.enquiry?.assignCounsellor,

            remarks: enrollment?.remarks,

            // Documents
            studentPhoto: enrollment?.registration?.studentPhoto ?? enrollment?.application?.studentPhoto ?? enrollment?.studentPhoto,

            // Additional Fields
            customFields: enrollment?.customFields
        };

        console.log('✅✅✅final enrolling payload: ', payload);

        const url = `${baseUrlAdmin}/user/addUser`;

        let userToSave = {
            ...payload,
            // phone_number: `+91${payload.phone_number}`
            phone_number: `+${this.state.parents[0]?.countryCode || '91'}${payload.phone_number}`
        };

        this.service
            .post(url, userToSave, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            viewEnrollment: false,
                            userCreatedInfo: res?.res?.data,
                            isStudentEnrolledConfirmed: true
                        },
                        () => { this.onShowFeeStructureDetails(); this.props.fetchStudents(); }

                    );
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: e.message, life: 3000 });
            });
    };
    onHandleReject = () => {
        this.setState({
            isRaiseDialogOpen: true
        });
    };
    onShowFeeStructureDetails = async () => {
        this.state.isOptedForTransport && (await this.getTransportFeeStructure());
        await this.getFeeStructures();
        this.setState({ isShowFeeStructure: true });
    };
    onRejectUser = () => {
        this.setState({
            isLoading: true
        });
        const url = `${baseUrlAdmin}/admissions/rejectEnrollment`;
        let payload = {
            remarks: this.state.remarks,
            _id: this.state.enrollment?._id
        };
        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            isRaiseDialogOpen: false,
                            viewEnrollment: false
                        },
                        () => {
                            this.props.navigate('/admission-enrollment')
                        }
                    );
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    getTransportFeeStructure = async () => {
        this.setState({
            isLoading: true
        });
        const { enrollment } = this.state;
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/fee-structure/transportfees?academicYear=${academicYear}&isNew=${true}`;
        this.service
            .get(url, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res?.data?.length) {
                        this.setState({
                            isLoading: false,
                            feeStructure: res.res.data || []
                        });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'success', summary: 'success', detail: 'No records found.', life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
                console.log(e);
            });
    };
    getFeeStructures = () => {
        this.setState({
            isLoading: true
        });
        const { enrollment } = this.state;

        // Build query parameters for the fee schedules API
        const params = new URLSearchParams({
            academicYear: enrollment?.academicSession || '',
            branchId: enrollment?.branch || ''
        });


        let url = `${baseUrlAdmin}/fee-structure?${params.toString()}`;
        console.log('Fetching Fee Structures with URL:', url);

        this.service
            .get(url, true)
            .then((res) => {
                console.log('Fee Structure API Response:', res);
                if (res && res.status && res.res.status) {
                    // Extract fee data from response - it's in res.res.data.response
                    const feeData = res.res.data?.response || res.res.data || [];
                    console.log('Fee Structure Data:', feeData);

                    if (feeData && feeData.length > 0) {
                        // Map the response to ensure consistent structure
                        // Handle _id as buffer or string, and use scheduleName
                        const mappedFeeStructures = feeData.map(item => {
                            // Convert _id buffer to string if needed
                            let idValue = item._id;
                            if (item._id && item._id.buffer) {
                                // Convert buffer to hex string
                                const buffer = new Uint8Array(item._id.buffer);
                                idValue = Array.from(buffer)
                                    .map(b => b.toString(16).padStart(2, '0'))
                                    .join('');
                            } else if (typeof item._id === 'object' && item._id !== null) {
                                idValue = item._id.toString();
                            }

                            return {
                                id: idValue || item.id || item.feeStructureId,
                                feeStructureName: item.scheduleName || item.feeStructureName || item.name,
                                ...item // Keep all other properties
                            };
                        });

                        console.log('Mapped Fee Structures:', mappedFeeStructures);

                        this.setState({
                            isLoading: false,
                            feeStructureR: mappedFeeStructures
                        });
                    }
                    else {
                        this.setState({
                            isLoading: false,
                            feeStructureR: []
                        });
                        this.toast.show({ severity: 'error', summary: 'No Fee Structures found.', detail: 'No fee structures available for the selected branch and academic year.', life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false,
                        feeStructureR: []
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false,
                    feeStructureR: []
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                console.log(e);
            });
    };

    getSelectedFeeStructure = async (selectedFeeStructure, isRegularStructure) => {
        if (selectedFeeStructure) {
            this.setState({
                isLoading: true
            });

            let url = `${baseUrlAdmin}/fee-structure/selectedFee/${selectedFeeStructure}?academicYear=${this.state?.enrollment?.academicSession}`;
            console.log("Selected Fee Structure URL:=========", url);

            this.service
                .get(url, true)
                .then((res) => {
                    if (res && res.status && res.res.status) {
                        if (res.res.data && res.res?.status) {
                            this.setState({
                                isLoading: false,
                                ...(isRegularStructure && { regularFeeStructureDetails: res.res.data }),
                                ...(!isRegularStructure && { feeStructureDetails: res.res.data })
                            });
                        }
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                    }
                })
                .catch((e) => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                    console.log(e);
                });
        }
    };

    feeStructureAssign = (isRegularFee) => {
        const { userCreatedInfo } = this.state;
        this.setState({ isLoading: true });
        let inputKey = userCreatedInfo?.user_info?.sectionId ? 'user_id' : '';

        console.log('=== Fee Schedule Assignment Debug ===');
        console.log('isRegularFee:', isRegularFee);
        console.log('userCreatedInfo:', userCreatedInfo);
        console.log('inputKey:', inputKey);

        if (inputKey == '') {
            // Error Msg Section is not assigned to user
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: `Error`, detail: 'Section is not assigned to user', life: 3000 });
            return;
        }

        let feeTypes = [];
        let feeStructureDetails = [];
        let selectedFeeStructure;

        if (!isRegularFee) {
            feeStructureDetails = this.state.feeStructureDetails;
            this.state.feeStructureDetails?.stepOne?.map((each) => feeTypes.push(each?.feeTypeId));
            selectedFeeStructure = this.state?.selectedFeeStructure;
        } else {
            feeStructureDetails = this.state.regularFeeStructureDetails;
            this.state.regularFeeStructureDetails?.stepOne?.map((each) => feeTypes.push(each?.feeTypeId));
            selectedFeeStructure = this.state?.selectedRFeeStructure;
        }

        console.log('feeStructureDetails:', feeStructureDetails);
        console.log('selectedFeeStructure ID:', selectedFeeStructure);
        console.log('feeTypes extracted:', feeTypes);
        console.log('feeTypes length:', feeTypes?.length);

        // Validation checks
        if (!selectedFeeStructure) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'Please select a fee schedule', life: 3000 });
            return;
        }

        if (!feeStructureDetails?.feeCategory) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'Fee category is missing', life: 3000 });
            return;
        }

        if (!feeTypes?.length) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'No fee types found in the selected schedule', life: 3000 });
            return;
        }

        let payload = {
            branchId: userCreatedInfo?.user_info?.branchId,
            boardId: userCreatedInfo?.user_info?.boardId,
            classId: userCreatedInfo?.user_info?.classId,
            sectionId: userCreatedInfo?.user_info?.sectionId,
            academicYear: userCreatedInfo?.user_info?.academicYear,
            feeCategoryId: feeStructureDetails?.feeCategory,
            feeStructureId: selectedFeeStructure,
            feeTypes: feeTypes,
            assignedInfo: [
                {
                    [inputKey]: userCreatedInfo?.user_id
                }
            ]
        };

        console.log('Assignment Payload:', JSON.stringify(payload, null, 2));

        let url = `${baseUrlAdmin}/fee-structure/assign`;
        console.log('API URL:', url);

        this.service
            .post(url, payload, true)
            .then((res) => {
                console.log('API Response:', res);
                if (res?.status && res?.res?.status) {
                    this.setState({
                        isLoading: false,
                        ...(isRegularFee && { isRegularFeeStructureAssigned: true, regularFeeStructureDetails: "" }),
                        ...(!isRegularFee && { isFeeStructureAssigned: true, feeStructureDetails: "" })
                    });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message || 'Fee schedule assigned successfully', life: 3000 });
                    console.log('✓ Fee schedule assignment successful');
                } else {
                    this.setState({ isLoading: false });
                    console.error('Assignment failed - Response status false:', res);
                    this.toast.show({ severity: 'error', summary: 'Assignment Failed', detail: res?.res?.message || res.errMessage || 'Failed to assign fee schedule', life: 3000 });
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                console.error('Assignment error:', err);
                this.toast.show({ severity: 'error', summary: 'Error', detail: err.message || 'An error occurred while assigning fee schedule', life: 3000 });
            });
    };

    onAssignTransportFee = () => {
        const { userCreatedInfo } = this.state;
        let stopInfo = this.state.routesList.filter((el) => el.stopId === this.state.requestedStop);
        let payload = {
            stopInfo,
            user_id: userCreatedInfo?.user_id,
            academicYear: userCreatedInfo?.user_info?.academicYear,
            requestedStop: this.state.requestedStop
        };

        let url = `${baseUrlAdmin}/admissions/assign/transport`;

        this.service
            .post(url, payload, true)
            .then((res) => {

                if (res?.status && res?.res?.status) {
                    this.setState(
                        {
                            isLoading: false
                        },
                        () => {
                            this.feeStructureAssign(false);
                        }
                    );
                    this.toast.show({ severity: 'info', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {

                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'No More Seats in this Route', life: 3000 });
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: err?.message, life: 3000 });
            });
    };

    onCloseOfFeeStructure = () => {
        this.setState({ isCloseOfFeeStructure: true });
    };
    showConfirmDialog = () => {
        this.setState({ isCredeintalsDisplay: true, isShowFeeStructure: false });
    };

    // Comprehensive validation for all required fields
    validateRequiredFields = () => {
        const { enrollment, parents } = this.state;
        const missingFields = [];

        // Academic Information
        if (!enrollment?.academicSession) missingFields.push('Academic Year');
        if (!enrollment?.academicCategory) missingFields.push('Admission Category');
        if (!enrollment?.branch) missingFields.push('Branch');
        if (!enrollment?.board) missingFields.push('Board');
        if (!enrollment?.grade) missingFields.push('Grade');

        // Previous School Information
        if (!enrollment?.previousSchool || enrollment.previousSchool.trim() === '') missingFields.push('Previous School');
        if (!enrollment?.previousBoard) missingFields.push('Previous Board');
        if (!enrollment?.previousGrade) missingFields.push('Previous Grade');

        // Student Personal Information
        if (!enrollment?.firstName || enrollment.firstName.trim() === '') missingFields.push('Student First Name');
        if (!enrollment?.lastName || enrollment.lastName.trim() === '') missingFields.push('Student Last Name');
        if (!enrollment?.gender) missingFields.push('Gender');
        if (!enrollment?.dob) missingFields.push('Date of Birth');
        if (!enrollment?.studentPhoto) missingFields.push('Student Photo');

        // Identity Information
        if (!enrollment?.nationality) missingFields.push('Nationality');
        if (!enrollment?.govtIdType) missingFields.push('Government ID Type');
        if (!enrollment?.idDetails || enrollment.idDetails.trim() === '') missingFields.push('ID Details');

        // Additional Personal Information
        if (!enrollment?.religion) missingFields.push('Religion');
        if (!enrollment?.motherTongue) missingFields.push('Mother Tongue');
        if (!enrollment?.caste) missingFields.push('Caste');

        // Student Contact Information
        if (!enrollment?.stdCountryCode) missingFields.push('Student Country Code');
        if (!enrollment?.stdContactNo || enrollment.stdContactNo.trim() === '') missingFields.push('Student Contact Number');
        if (!enrollment?.stdEmailId || enrollment.stdEmailId.trim() === '') missingFields.push('Student Email ID');

        // Identification Marks
        if (!enrollment?.identificationMarks || enrollment.identificationMarks.trim() === '') missingFields.push('Identification Marks');

        // Parent Information - At least one parent is required
        if (!parents || parents.length === 0) {
            missingFields.push('Parent/Guardian Information');
        } else {
            const firstParent = parents[0];
            if (!firstParent?.parentType) missingFields.push('Parent Relationship');
            if (!firstParent?.parentName || firstParent.parentName.trim() === '') missingFields.push('Parent Name');
            if (!firstParent?.qualification || firstParent.qualification.trim() === '') missingFields.push('Parent Qualification');
            if (!firstParent?.profession || firstParent.profession.trim() === '') missingFields.push('Parent Profession');
            if (!firstParent?.countryCode) missingFields.push('Parent Country Code');
            if (!firstParent?.parentContact || firstParent.parentContact.trim() === '') missingFields.push('Parent Contact Number');
            if (!firstParent?.parentEmailId || firstParent.parentEmailId.trim() === '') missingFields.push('Parent Email ID');
        }

        // Address Information
        if (!enrollment?.addressLine || enrollment.addressLine.trim() === '') missingFields.push('Address Line');
        if (!enrollment?.pinCode || enrollment.pinCode.trim() === '') missingFields.push('Pincode');
        if (!enrollment?.state) missingFields.push('State');
        if (!enrollment?.cityOrDist) missingFields.push('City/District');

        // Transport validation
        if (enrollment?.transportRequired && (!enrollment?.requestedStop || enrollment.requestedStop.trim() === '')) {
            missingFields.push('Requested Stop (Transport is required)');
        }

        return missingFields;
    };

    // Save enrollment without confirming (similar to registration save)
    onSaveEnrollment = async () => {
        this.setState({ isLoading: true });

        const { enrollment } = this.state;

        // Comprehensive validation of all required fields
        const missingFields = this.validateRequiredFields();

        if (missingFields.length > 0) {
            this.setState({ isLoading: false });

            // Show detailed error message with first 5 missing fields
            const fieldsToShow = missingFields.slice(0, 5);
            const remainingCount = missingFields.length - fieldsToShow.length;
            const detailMessage = remainingCount > 0
                ? `${fieldsToShow.join(', ')} and ${remainingCount} more field(s)`
                : fieldsToShow.join(', ');

            this.toast.show({
                severity: 'error',
                summary: 'Required Fields Missing',
                detail: `Please fill the following required fields: ${detailMessage}`,
                life: 5000
            });

            console.log('Missing required fields:', missingFields);
            return;
        }

        // Validate transport required fields
        if (enrollment?.transportRequired && (!enrollment?.requestedStop || enrollment?.requestedStop?.trim() === "")) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Requested Stop Required',
                detail: 'Please enter the requested stop when transport is required',
                life: 3000
            });
            return;
        }

        // Prepare enrollment data
        enrollment.siblings = this.state.siblings;
        enrollment.prevAcademicDetails = this.state.prevAcademicDetails;
        enrollment.studentPhoto = enrollment?.studentPhoto || enrollment?.application?.studentPhoto;
        enrollment.pinCode = enrollment?.pinCode || enrollment?.application?.pinCode;
        enrollment.cityOrDist = enrollment?.cityOrDist || enrollment?.application?.cityOrDist;
        enrollment.state = enrollment?.state || enrollment?.application?.state;

        // Validate form using existing validation logic
        const formStatus = isFormValid(createEnrollmentFields, this.formFields.formValidations, trimObj(enrollment));
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
                isLoading: false
            });
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please fill all required fields correctly',
                life: 3000
            });
            return;
        }

        const academicSession = localStorage.getItem('userAcademicYear');

        let payload = {
            enrollmentData: enrollment,
            stage: "Enrollment",
            _id: enrollment?._id,
            academicSession: academicSession,
            academicCategory: enrollment?.academicCategory || enrollment?.enquiry?.academicCategory,
            categoryName: enrollment?.admissionCategoryName || enrollment?.enquiry?.admissionCategoryName,
            branch: enrollment?.branch,
            branchName: enrollment?.branchName,
            board: enrollment?.board,
            boardName: enrollment?.boardName,
            grade: enrollment?.grade,
            gradeName: enrollment?.gradeName,
            applicationId: enrollment?.applicationId,

            // Student information
            firstName: enrollment?.firstName,
            middleName: enrollment?.middleName,
            lastName: enrollment?.lastName,
            dob: enrollment?.dob,
            gender: enrollment?.gender,

            // Student contact information
            stdCountryCode: enrollment?.stdCountryCode,
            stdContactNo: enrollment?.stdContactNo,
            stdEmailId: enrollment?.stdEmailId,

            // Backward compatibility fields - synced from first parent
            contactNo: enrollment?.contactNo || this.state.parents[0]?.parentContact,
            emailId: enrollment?.emailId || this.state.parents[0]?.parentEmailId,

            // Identity
            govtIdType: enrollment?.govtIdType,
            idDetails: enrollment?.idDetails,
            nationality: enrollment?.nationality,

            // Parent information
            parentType: this.state.parents[0]?.parentType,
            parentName: this.state.parents[0]?.parentName,
            contactNo: this.state.parents[0]?.parentContact,
            emailId: this.state.parents[0]?.parentEmailId,
            parentContact: this.state.parents[0]?.parentContact,
            parentEmailId: this.state.parents[0]?.parentEmailId,
            countryCode: this.state.parents[0]?.countryCode,
            parentQualification: this.state.parents[0]?.qualification || this.state.parents[0]?.parentQualification,
            occupation: this.state.parents[0]?.profession || this.state.parents[0]?.occupation,
            parents: this.state.parents,
            siblings: this.state.siblings,

            // Transport
            transportRequired: enrollment?.transportRequired,
            requestedStop: enrollment?.requestedStop,

            // Other fields
            prevAcademicDetails: this.state.prevAcademicDetails,
            studentPhoto: enrollment?.studentPhoto,
            customFields: enrollment?.customFields
        };

        try {
            const url = `${baseUrlAdmin}/admissions/add-enrollment`;
            const res = await this.service.post(url, payload, true);

            if (res && res.status && res.res.status) {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.state.isEdit ? 'Enrollment updated successfully' : 'Enrollment saved successfully',
                    life: 3000
                });

                // Reload the enrollment data using the admission record _id (MongoDB ObjectId)
                if (enrollment?._id) {
                    await this.getAdmissionInfo(enrollment._id);
                }
            } else {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: res?.errMessage || 'Failed to save enrollment',
                    life: 3000
                });
            }
        } catch (error) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error?.message || 'An error occurred while saving',
                life: 3000
            });
        }
    };

    // Parent management methods
    addParent = () => {
        this.setState((prevState) => ({
            parents: [
                ...prevState.parents,
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    countryCode: '',
                    parentContact: '',
                    parentEmailId: '',
                }
            ],
            parentValidations: [...prevState.parentValidations, {}]
        }));
    };

    removeParent = (index) => {
        this.setState((prevState) => {
            const updatedParents = prevState.parents.filter((_, i) => i !== index);
            const updatedValidations = prevState.parentValidations.filter((_, i) => i !== index);
            return { parents: updatedParents, parentValidations: updatedValidations };
        });
    };

    previewConfirmEnrollment = async () => {
        // Show loading while fetching fee data
        this.setState({ isLoading: true });

        // Fetch latest fee paid info before navigating to preview
        let receiptInfoToPass = this.state.receiptInfo || {};

        if (this.state.enrollment?._id) {
            try {
                const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${this.state.enrollment._id}`;
                const res = await this.service.get(url, true);

                if (res && res.status && res.res.status && res.res.data) {
                    receiptInfoToPass = res.res.data;
                    // Update state with the latest receipt info
                    this.setState({ receiptInfo: receiptInfoToPass });
                }
            } catch (error) {
                console.error('Error fetching fee paid info for preview:', error);
            }
        }

        // Hide loading before navigation
        this.setState({ isLoading: false });

        // Navigate to preview component with enrollment data
        this.props.navigate('/preview-confirm-enrollment', {
            state: {
                enrollment: this.state.enrollment,
                parents: this.state.parents,
                siblings: this.state.siblings,
                receiptInfo: receiptInfoToPass,
                academicCategoryOptions: this.state.academicCategory || [],
                academicSessionOptions: this.state.academicSessions || []
            }
        });
    };

    onParentChange = (value, index, field) => {
        const updatedParents = [...this.state.parents];
        let validationError = null;

        // Apply validation for specific fields
        if (field === 'parentContact') {
            // Only allow digits and limit to 10
            const numericValue = value.replace(/\D/g, '').slice(0, 10);
            updatedParents[index][field] = numericValue;

            if (numericValue && numericValue.length < 10) {
                validationError = 'Contact number must be exactly 10 digits';
            }
        } else if (field === 'parentEmailId') {
            updatedParents[index][field] = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (value && !emailRegex.test(value)) {
                validationError = 'Please enter a valid email address';
            }
        } else {
            updatedParents[index][field] = value;
        }

        // Update parent validations
        const updatedParentValidations = [...this.state.parentValidations];
        if (!updatedParentValidations[index]) {
            updatedParentValidations[index] = {};
        }
        updatedParentValidations[index][field] = {
            isValid: !validationError,
            errorMsg: validationError || ''
        };

        const updatedEnrollment = { ...this.state.enrollment };

        // Only sync the first parent's data to the enrollment object for validation and backward compatibility
        if (index === 0) {
            if (field === 'parentType') updatedEnrollment.parentType = value;
            if (field === 'parentName') updatedEnrollment.parentName = value;
            if (field === 'countryCode') updatedEnrollment.countryCode = value;
            if (field === 'qualification') {
                updatedEnrollment.qualification = value;
                updatedEnrollment.parentQualification = value; // Backward compatibility
            }
            if (field === 'profession') {
                updatedEnrollment.profession = value;
                updatedEnrollment.occupation = value; // Backward compatibility
            }

            if (field === 'parentContact') {
                // Use the validated/formatted value from updatedParents
                updatedEnrollment.parentContact = updatedParents[0][field];
                updatedEnrollment.contactNo = updatedParents[0][field]; // Backward compatibility
            }
            if (field === 'parentEmailId') {
                updatedEnrollment.parentEmailId = value;
                updatedEnrollment.emailId = value; // Backward compatibility
            }
        }

        const updatedFormValidations = { ...this.state.formValidations };
        if (index === 0 && this.formFields.formValidations.fields[field]) {
            updatedFormValidations.fields[field] = {
                isValid: !validationError,
                errorMsg: validationError || ''
            };
        }

        this.setState({
            parents: updatedParents,
            parentValidations: updatedParentValidations,
            enrollment: updatedEnrollment,
            formValidations: updatedFormValidations
        });
    };

    // Sibling management methods
    onChangeInput = (value, index, field, arr) => {
        if (arr === "siblings") {
            const updatedSiblings = [...this.state.siblings];
            updatedSiblings[index][field] = value;
            this.setState({ siblings: updatedSiblings });
        }
    };

    onCliclAddSibling = (add, index) => {
        if (add) {
            this.setState((prevState) => ({
                siblings: [
                    ...prevState.siblings,
                    { name: "", gender: "", classStudying: "", schoolStudying: "" }
                ]
            }));
        } else {
            this.setState((prevState) => {
                const updatedSiblings = prevState.siblings.filter((_, i) => i !== index);
                return { siblings: updatedSiblings };
            });
        }
    };

    // File upload methods
    _onStudentPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    };

    addAttachment = (fieldName, fileName, data) => {
        this.setState((prevState) => ({
            enrollment: {
                ...prevState.enrollment,
                [fieldName]: {
                    fileName,
                    storageBucket: data.Bucket,
                    storageKey: data.Key,
                    storageLocation: data.Location
                }
            }
        }));
    };

    // Contact number validation - exactly 10 digits
    onContactNumberChange = (value, fieldName) => {
        // Allow only digits and limit to 10 characters
        const numericValue = value.replace(/\D/g, '').slice(0, 10);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 10) {
            validation = {
                isValid: false,
                errorMsg: 'Contact number must be exactly 10 digits'
            };
        } else if (numericValue && numericValue.length === 10) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                [fieldName]: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Email validation with proper format check
    onEmailChangeWithValidation = (value, fieldName) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let validation = { isValid: true, errorMsg: '' };

        if (value && !emailRegex.test(value)) {
            validation = {
                isValid: false,
                errorMsg: 'Please enter a valid email address'
            };
        } else if (value) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                [fieldName]: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Pincode validation - exactly 6 digits
    onPincodeChange = (value) => {
        // Allow only digits and limit to 6 characters
        const numericValue = value.replace(/\D/g, '').slice(0, 6);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 6) {
            validation = {
                isValid: false,
                errorMsg: 'Pincode must be exactly 6 digits'
            };
        } else if (numericValue && numericValue.length === 6) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                pinCode: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    pinCode: validation
                }
            }
        }));
    };

    // ID validation methods
    validateIdDetails = (value, govtIdType) => {
        if (!value) return { isValid: true, errorMsg: '' };

        switch (govtIdType) {
            case 'aadhaar':
                if (!/^\d{12}$/.test(value)) {
                    return { isValid: false, errorMsg: 'Aadhaar number must be 12 digits' };
                }
                break;
            case 'passport':
                if (!/^[A-Z][0-9]{7}$/.test(value)) {
                    return { isValid: false, errorMsg: 'Passport number format is invalid' };
                }
                break;
            default:
                break;
        }
        return { isValid: true, errorMsg: '' };
    };

    onIdDetailsChange = (value) => {
        const { enrollment } = this.state;
        const validation = this.validateIdDetails(value, enrollment.govtIdType);

        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                idDetails: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    idDetails: validation
                }
            }
        }));
    };

    onGovtIdTypeChange = (value) => {
        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                govtIdType: value,
                idDetails: ''
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    govtIdType: { isValid: true, errorMsg: '' },
                    idDetails: { isValid: true, errorMsg: '' }
                }
            }
        }));
    };

    // Custom handler for academic category dropdown to store both ID and name
    onAcademicCategoryChange = (selectedValue) => {
        const selectedCategory = this.state.academicCategory.find(cat => cat.value === selectedValue);

        // Update enrollment with both the ID and the category name
        this.setState(prevState => ({
            enrollment: {
                ...prevState.enrollment,
                academicCategory: selectedValue,
                admissionCategoryName: selectedCategory?.label || ''
            }
        }), () => {
            // Call the original form validation after state update
            onDropDownChange(
                selectedValue,
                'academicCategory',
                this,
                createEnrollmentFields,
                this.state.enrollment,
                this.state.formValidations,
                'enrollment',
                'formValidations'
            );
        });
    };

    // Toggle and form change methods
    onToggleChange = (e, field) => {
        let data = JSON.parse(JSON.stringify(this.state.enrollment));
        let formValidations = this.state.formValidations;
        data[field] = e.value;

        let fieldInfo = createEnrollmentFields.filter((f) => f.FieldName == field);
        if (formValidations.fields[field] && formValidations.fields[field].isRequired) {
            if (e.value !== null && e.value !== undefined && e.value !== '') {
                formValidations.fields[field].isValid = true;
                formValidations.fields[field].errorMsg = '';
            }
        }

        // Handle transport toggle
        if (field === 'transportRequired') {
            this.setState(
                {
                    enrollment: data,
                    formValidations,
                    isOptedForTransport: e.value,
                    selectedFeeStructure: null,
                    feeStructure: [],
                    routesList: []
                },
                () => {
                    if (e.value) {
                        this.getTransportInfo();
                        this.getTransportFeeStructure(e.value);
                    }
                }
            );
        } else {
            this.setState({
                enrollment: data,
                formValidations
            });
        }
    };

    onEmailChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName, optionalRequired) => {
        let data = JSON.parse(JSON.stringify(formData));
        data[fieldName] = value;
        let fieldInfo = formFields.filter((f) => f.FieldName == fieldName);
        fieldInfo = fieldInfo[0];

        if (value != '' && optionalRequired) {
            if (formValidations.fields[fieldName]) {
                formValidations.fields[fieldName].isRequired = true;
            }
        }
        if (value == '' && optionalRequired) {
            if (formValidations.fields[fieldName]) {
                formValidations.fields[fieldName].isRequired = false;
            }
        }

        if (formValidations.fields[fieldName] && formValidations.fields[fieldName].isRequired) {
            if (value !== null && value !== undefined && value !== '') {
                formValidations.fields[fieldName].isValid = true;
                formValidations.fields[fieldName].errorMsg = '';
            }
        } else {
            if (formValidations.fields[fieldName]) {
                formValidations.fields[fieldName].isValid = true;
                formValidations.fields[fieldName].errorMsg = '';
            }
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    };

    // Branch and Board change methods
    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    onChangeBranch = (branchId, preserveSelection = false) => {
        this.setState({
            boards: [],
            classes: []
        });

        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;
        let filteredBoards = this.props.boards?.filter((board) => board.assignedBranches?.includes(branchId)) || [];
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        this.setState(prevState => ({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            selectedClassesList: preserveSelection ? prevState.selectedClassesList : [],
            boardId: preserveSelection ? prevState.boardId : '',
            selectedBoardName: preserveSelection ? prevState.selectedBoardName : '',
            classId: preserveSelection ? prevState.classId : '',
            selectedClass: preserveSelection ? prevState.selectedClass : {},
            branches: [],
            selectedClassName: preserveSelection ? prevState.selectedClassName : '',
            enrollment: {
                ...prevState.enrollment,
                branchName: selectedbranchName,
                ...(preserveSelection ? {} : { board: '', boardName: '', grade: '', gradeName: '' })
            }
        }));
    };

    onChangeBoard = (boardId, preserveSelection = false) => {
        this.setState({
            classes: [],
            sections: []
        });
        const selectedBoard = this.state.boards?.find((board) => board.boardId === boardId) ||
            this.props.boards?.find((board) => board.boardId === boardId);

        // Filter classes based on admission settings grades
        let classesInfo = this.state.admissionSettingsInfo?.grades || [];
        let finalClassesList = [];

        for (const sClass of classesInfo) {
            for (let i = 0; i < (selectedBoard?.classes?.length || 0); i++) {
                const classId = selectedBoard?.classes[i]?.classId;
                if (sClass === classId) finalClassesList.push(selectedBoard?.classes[i]);
            }
        }

        // Remove duplicates from grades list
        finalClassesList = this.removeDuplicates(finalClassesList, 'classId');

        this.setState(prevState => ({
            classes: [],
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: preserveSelection ? prevState.classId : '',
            selectedClass: preserveSelection ? prevState.selectedClass : {},
            branches: [],
            selectedClassName: preserveSelection ? prevState.selectedClassName : '',
            selectedClassesList: finalClassesList,
            enrollment: {
                ...prevState.enrollment,
                boardName: selectedBoard?.boardName,
                ...(preserveSelection ? {} : { grade: '', gradeName: '' })
            }
        }), () => {
            // Fetch age criteria if branch is selected and DOB exists
            if (this.state.branchId && boardId) {
                this.getAgeCriteriaInfo(this.state.branchId, boardId, finalClassesList);
            } else if (finalClassesList.length > 0) {
                // If no age criteria, just show all filtered classes
                this.setState({ classes: finalClassesList });
            }
        });
    };

    onStateChange = (selectedState) => {
        // Get districts for selected state from districts.json
        const stateDistricts = districts[selectedState] || [];

        // Transform districts to dropdown format
        let transformedDistricts = stateDistricts.map(district => ({
            label: district,
            value: district
        }));

        // If no districts found for the selected state, add "Other" option
        if (transformedDistricts.length === 0) {
            transformedDistricts = [{ label: 'Other', value: 'Other' }];
        }

        this.setState(prevState => ({
            cityOrDist: transformedDistricts,
            enrollment: {
                ...prevState.enrollment,
                state: selectedState,
                cityOrDist: ''
            }
        }), () => {
            onDropDownChange(
                selectedState,
                'state',
                this,
                formFields,
                this.state.enrollment,
                this.state.formValidations,
                'enrollment',
                'formValidations'
            );
        });
    };

    // File upload helper methods
    _onProgress = (filesInfo) => { };

    _afterFilesUploaded = (files) => {
        console.log(files);
    };

    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Some error', detail: errMsg, life: 3000 });
    };

    onChangeClass = (classId) => {
        const { classes } = this.state;
        let selectedClassId = classes?.find(el => el.classId === classId);
        let groupId = selectedClassId?.groups?.[0]?.groupId;
        let groupName = selectedClassId?.groups?.[0]?.groupName;

        this.setState(prevState => ({
            groupId: groupId,
            selectedClass: selectedClassId,
            selectedClassName: selectedClassId?.className || '',
            enrollment: {
                ...prevState.enrollment,
                gradeName: selectedClassId?.className || ''
            }
        }));
    };

    // Helper method to get academic year display value
    getAcademicYearDisplayValue = () => {
        const { enrollment } = this.state;
        const userAcademicYear = localStorage.getItem('userAcademicYear');
        const matchingSession = this.state.academicSessions?.find(session => session._id === userAcademicYear);
        return matchingSession?.academicCode || enrollment.academicYearCode || enrollment.enquiry?.academicYearCode || userAcademicYear || '';
    };

    onSetClasses = () => {
        const { dob, enrollment, ageCriteriaInfo, admissionSettingsInfo, selectedClassesList } = this.state

        // If selectedClassesList is not available, return early
        if (!selectedClassesList || !Array.isArray(selectedClassesList)) {
            return;
        }

        // No board selected - cannot determine classes
        if (!enrollment?.board) {
            this.setState({ classes: [] });
            return;
        }

        if (admissionSettingsInfo?.ageCriteria) {
            let classesInfo
            if (dob && enrollment?.board) {
                // Check if age criteria data exists for the selected board
                if (!ageCriteriaInfo || !Array.isArray(ageCriteriaInfo) || ageCriteriaInfo.length === 0) {
                    // No age criteria configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Check if any grade has valid dates configured (not null/undefined)
                const hasValidDates = ageCriteriaInfo.some(cls =>
                    cls.bornBefore && cls.bornAfter &&
                    cls.bornBefore !== null && cls.bornAfter !== null
                );

                if (!hasValidDates) {
                    // Dates not configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Age criteria is configured with valid dates, filter based on DOB
                classesInfo = ageCriteriaInfo.filter(cls => {
                    // Skip grades without valid dates
                    if (!cls.bornBefore || !cls.bornAfter) return false;

                    const dateOfBirth = new Date(dob.toDateString());
                    const bornBeforeDate = new Date(new Date(cls.bornBefore).toDateString());
                    const bornAfterDate = new Date(new Date(cls.bornAfter).toDateString());

                    return dateOfBirth >= bornAfterDate && dateOfBirth <= bornBeforeDate;
                });
                const classIds = new Set(classesInfo.map(item => item.classId));


                const matchedClasses = selectedClassesList.filter(item => classIds.has(item.classId));
                if (!matchedClasses.length) {
                    // Age criteria is configured but DOB doesn't match any grade - show error
                    this.setState({
                        isLoading: false,
                        classes: [],
                        enrollment: {
                            ...this.state.enrollment,
                            grade: ''
                        }
                    });
                    this.toast?.show({ severity: 'error', summary: 'Age not eligible for any grades', detail: "Age not eligible for any grades", life: 3000 });
                } else {
                    // Check if currently selected grade is still in the matched classes
                    const isSelectedGradeValid = matchedClasses.some(cls => cls.classId === this.state.enrollment.grade);

                    this.setState({
                        classes: matchedClasses,
                        enrollment: {
                            ...this.state.enrollment,
                            grade: isSelectedGradeValid ? this.state.enrollment.grade : ''
                        }
                    })
                }
            } else if (!dob) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please select DOB', detail: "Please select DOB", life: 3000 });
            } else {
                this.setState({
                    classes: selectedClassesList
                })
            }

        } else {
            this.setState({
                classes: selectedClassesList
            })
        }
    }

    getAgeCriteriaInfo = async (branchId, boardId, finalClassesList) => {
        this.setState({
            isLoading: true
        });
        const { dob, enrollment, admissionSettingsInfo, ageCriteriaInfo } = this.state
        const academicYear = enrollment?.academicSession || localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/agecriteria?boardId=${boardId}&branchId=${branchId}&academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {

                this.setState({ ageCriteriaInfo: res?.res?.data, isLoading: false }, () => this.onSetClasses(finalClassesList));
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    }

    onEmailChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName, optionalRequired) => {
        let data = JSON.parse(JSON.stringify(formData));
        data[fieldName] = value;
        let fieldInfo = formFields.filter((f) => f.FieldName == fieldName);
        fieldInfo = fieldInfo[0];
        if (value != '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = true
        }
        if (value == '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = false
        }
        if (formValidations.fields[fieldName].isRequired) {
            if (data[fieldName] == '' || data[fieldName] == null) {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: false,
                    errorMsg: `${fieldInfo.RequiredMsg ? fieldInfo.RequiredMsg : fieldInfo.Label + ' is required'}`
                }
                formValidations.isFormValid = false;
            }
            // else if ((data[fieldName] != '' && data[fieldName] != null) && !isValidEmail(data[fieldName])) {
            //     formValidations.fields[fieldName] = {
            //         ...formValidations.fields[fieldName],
            //         isValid: false,
            //         errorMsg: `${fieldInfo.Label} is invalid.`
            //     }
            //     formValidations.isFormValid = false;
            // } 
            else {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        } else {
            if (optionalRequired && value == '') {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    }


    render() {
        const { enrollment, payFeeFormData, payFormValidations, receiptInfo, formValidations, payformValidations } = this.state;
        const formFields = createEnrollmentFields;
        return (
            <>
                <div>
                </div>


                <div className=''>
                    <div className='flex justify-content-end align-items-center mb-4'>
                        {this.state.isShowPayFeeButton && (
                            <Button
                                disabled={this.state.isEnrollmentFeePaid ? true : false}
                                className="add-vehicle-btn"
                                style={{ width: '120px', paddingLeft: '25px' }}
                                onClick={() => this.openDailogPayAppFee()}
                            >
                                Pay Fee
                            </Button>
                        )}
                    </div>

                    <br />
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Academic Details</u>
                        </h1>
                    </div>

                    {/* Admission Year, Academic Category */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >


                        {/* {registration?.applicationId && */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Application ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    // id="title"
                                    className='  add-vehicle-field-input w-full '
                                    value={enrollment.applicationId}
                                    onChange={(e) => onTextChange(e.target.value, 'applicationId', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                    placeholder="Application ID"
                                    disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['applicationId']?.isValid && <p className="p-error text-lg">{formValidations.fields['applicationId']?.errorMsg}</p>}
                        </div>
                        {/* } */}
                        {/* </div> */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Academic Year<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    className='text-xl add-vehicle-field-input w-full'
                                    // value={enrollment.academicYearCode || enrollment.enquiry?.academicYearCode || ''}
                                    value={this.getAcademicYearDisplayValue()}
                                    placeholder='Academic Year'
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicSession']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['academicSession']?.errorMsg}</p>
                            )}
                        </div>
                        {/* </div> */}
                        {/* Admission Category dropdown */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Admission Category<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.academicCategory}
                                    options={this.state.academicCategory}
                                    onChange={(e) => this.onAcademicCategoryChange(e.target.value)}
                                    placeholder='Admission Category'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['academicCategory']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['academicCategory']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Branch board grade */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Branch<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='name'
                                    optionValue='key'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.branch}
                                    options={this.props.branchData}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'branch', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations'); this.onChangeBranch(e.target.value) }}
                                    placeholder='Select Branch'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['branch']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['branch']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='boardName'
                                    optionValue='boardId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.board}
                                    options={this.state.boards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'board', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations'); this.onChangeBoard(e.target.value) }}
                                    placeholder='Select Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['board']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['board']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='className'
                                    optionValue='classId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.grade}
                                    options={this.state?.classes}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'grade', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations'); this.onChangeClass(e.target.value) }}
                                    placeholder='Select Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['grade']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['grade']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Prev  Branch board grade */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous School<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className=' add-vehicle-field-input w-full '
                                    value={enrollment.previousSchool}
                                    onChange={(e) => onTextChange(e.target.value, 'previousSchool', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                    placeholder="Previous School" />
                            </div>
                            {formValidations && !formValidations.fields?.['previousSchool']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['previousSchool']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">

                            <p className='transport-fee-form-label'>Previous Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.previousBoard}
                                    options={this.state.previousBoards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'previousBoard', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations') }}
                                    placeholder='Select Previous Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['previousBoard']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['previousBoard']?.errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.previousGrade}
                                    options={gradePriorityOptions}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'previousGrade', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations');
                                    }}
                                    placeholder='Select Previous Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousGrade']?.isValid && <p className="p-error text-lg">{formValidations.fields['previousGrade']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Student | Personal Details */}
                    <br />
                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Personal Details</u>
                        </h1>
                    </div>
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student First Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={enrollment.firstName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'firstName', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations');
                                        }
                                    }}
                                    placeholder="Student First Name" />
                            </div>
                            {formValidations && !formValidations.fields?.['firstName']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['firstName']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Middle Name</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.middleName} // Corrected field
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'middleName', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations'); // Corrected field
                                        }
                                    }}
                                    placeholder="Student Middle Name"
                                />
                            </div>
                            {formValidations && !formValidations.fields['middleName']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['middleName']?.errorMsg}</p> // Corrected field
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Last Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={enrollment.lastName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'lastName', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')
                                        }
                                    }}
                                    placeholder="Student Last Name" />
                            </div>
                            {formValidations && !formValidations.fields?.['lastName']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['lastName']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Gender, DOB, Upload photo */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Gender<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}

                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.gender}
                                    options={this.state.gender}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'gender', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations') }}
                                    placeholder='Select Gender'
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['gender']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['gender']?.errorMsg}</p>}

                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Date of Birth<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetCalendar
                                    width={250}
                                    //
                                    className=' border-round-md add-vehicle-field-input text-xl w-full'
                                    calendarMode={'single'}
                                    value={this.state.dob ? new Date(this.state.dob) : null}
                                    onChange={(e) => {
                                        this.setState({
                                            dob: e.value,
                                            enrollment: { ...this.state.enrollment, dob: e.value }
                                        }, () => {
                                            // Re-fetch age criteria if board and branch are selected
                                            if (this.state.enrollment?.board && this.state.enrollment?.branch) {
                                                this.getAgeCriteriaInfo(
                                                    this.state.enrollment.branch,
                                                    this.state.enrollment.board,
                                                    this.state.selectedClassesList
                                                );
                                            } else {
                                                this.onSetClasses();
                                            }
                                        })
                                    }}
                                    placeholder="DOB"
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Upload Photo<span className='ma-required'>*</span>
                            </p>
                            <div className="flex">
                                <FileUpload
                                    id={'student'}
                                    multiple={false}
                                    onProgress={this._onProgress}
                                    onSucess={this._onStudentPhotoSuccess}
                                    maxFileSize={5242880}
                                    onError={this._onFilsUploadError}
                                    accept={'images'}
                                    title={'Upload Student Photo'}
                                    afterFilesUploaded={this._afterFilesUploaded}
                                    className="border-solid"
                                    disabled={this.state.isLoading}
                                >
                                    <ClassetInputText
                                        width={250}
                                        icon={<FileAttachmentIcon width={24} height={24} color={'black'} />}
                                        className="add-vehicle-field-input w-full"
                                        value={enrollment.studentPhoto?.fileName || ''}
                                        placeholder="Upload Photo"
                                        disabled={true}
                                    />
                                </FileUpload>
                            </div>
                            {formValidations && !formValidations.fields['studentPhoto']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['studentPhoto']?.errorMsg}</p>
                            )}
                        </div>
                    </div>

                    {/* Nationality, Govt Id, id details */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        {/* nationality */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Nationality<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='name'
                                    optionValue='code'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.nationality}
                                    options={this.state.countries}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'nationality', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations') }}
                                    placeholder='Select Nationality'
                                />
                            </div>
                            {formValidations && !formValidations.fields['nationality']?.isValid && <p className="p-error text-lg">{formValidations.fields['nationality']?.errorMsg}</p>}
                        </div>

                        {/* Gov ID */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Govt ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.govtIdType}
                                    options={this.state.govtIdTypes}
                                    onChange={(e) => {
                                        this.onGovtIdTypeChange(e.target.value);
                                    }}
                                    placeholder='Select Govt ID'
                                />
                            </div>
                            {formValidations && !formValidations.fields['govtIdType']?.isValid && <p className="p-error text-lg">{formValidations.fields['govtIdType']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>ID Details<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter={enrollment.govtIdType === 'aadhaar' ? 'int' : null} // Only allow numbers for Aadhaar
                                    maxLength={enrollment.govtIdType === 'aadhaar' ? 12 : enrollment.govtIdType === 'passport' ? 8 : undefined}
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.idDetails}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Apply specific filters based on govt ID type
                                        if (enrollment.govtIdType === 'aadhaar') {
                                            // Only allow digits for Aadhaar
                                            value = value.replace(/\D/g, '');
                                            if (value.length > 12) value = value.slice(0, 12);
                                        } else if (enrollment.govtIdType === 'passport') {
                                            // Only allow alphanumeric for Passport
                                            value = value.replace(/[^A-Za-z0-9]/g, '');
                                            if (value.length > 8) value = value.slice(0, 8);
                                            value = value.toUpperCase(); // Convert to uppercase for consistency
                                        }

                                        this.onIdDetailsChange(value);
                                    }}
                                    placeholder={
                                        enrollment.govtIdType === 'aadhaar' ? "Enter Aadhaar number"
                                            : enrollment.govtIdType === 'passport'
                                                ? "Enter Passport number"
                                                : "Enter ID Details"
                                    }
                                    disabled={!enrollment.govtIdType} // Disable if no govt ID type is selected
                                />
                            </div>
                            {formValidations && !formValidations.fields['idDetails']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['idDetails']?.errorMsg}</p>
                            )}
                            {/* Show format hint */}
                            {enrollment.govtIdType && (
                                <small className="p-text-secondary">
                                    {enrollment.govtIdType === 'aadhaar' && "Format: 12 digits (e.g., 123456789012)"}
                                    {enrollment.govtIdType === 'passport' && "Format: 8 alphanumeric characters (e.g., A1234567)"}
                                </small>
                            )}
                        </div>
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">Blood Group</p>
                            <div className="flex">
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    placeholder="Select Blood Group"
                                    className="add-vehicle-field-input"
                                    value={enrollment.bloodGroup}
                                    options={[
                                        { label: 'A+', value: 'A+' },
                                        { label: 'A-', value: 'A-' },
                                        { label: 'B+', value: 'B+' },
                                        { label: 'B-', value: 'B-' },
                                        { label: 'O+', value: 'O+' },
                                        { label: 'O-', value: 'O-' },
                                        { label: 'AB+', value: 'AB+' },
                                        { label: 'AB-', value: 'AB-' }
                                    ]}
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            enrollment: {
                                                ...prevState.enrollment,
                                                bloodGroup: e.value
                                            }
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Religion, Mother Tongue, Caste */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Religion<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.religion}
                                    options={this.state.religions}
                                    onChange={(e) => onDropDownChange(e.target.value, 'religion', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                    placeholder='Select Religion'
                                />
                            </div>
                            {formValidations && !formValidations.fields['religion']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['religion']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Mother Tongue<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.motherTongue}
                                    // onChange={(e) => onTextChange(e.target.value, 'motherTongue', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'motherTongue', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations');
                                    }}
                                    placeholder="Enter Language"
                                />
                            </div>
                            {formValidations && !formValidations.fields['motherTongue']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['motherTongue']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Caste<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.caste}
                                    options={this.state.castes}
                                    onChange={(e) => onDropDownChange(e.target.value, 'caste', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                    placeholder='Select Caste'
                                />
                            </div>
                            {formValidations && !formValidations.fields['caste']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['caste']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >


                        {/* // The Country Code dropdown remains the same - it will now use the JSON data */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enrollment.stdCountryCode}
                                    options={this.state.countryPhoneCodes} // This now uses JSON data
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'stdCountryCode', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations');
                                    }}
                                    placeholder='Select Country Phone Code'
                                />
                            </div>
                            {formValidations && !formValidations.fields['stdCountryCode']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdCountryCode']?.errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Contact no<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter='int'
                                    maxLength={10}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={enrollment.stdContactNo}
                                    onChange={(e) => this.onContactNumberChange(e.target.value, 'stdContactNo')}
                                    placeholder="Contact no (10 digits)" />
                            </div>
                            {formValidations && !formValidations.fields?.['stdContactNo']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['stdContactNo']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Email ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={enrollment.stdEmailId}
                                    onChange={(e) => this.onEmailChangeWithValidation(e.target.value, 'stdEmailId')}
                                    placeholder="Email ID" />
                            </div>
                            {formValidations && !formValidations.fields?.['stdEmailId']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['stdEmailId']?.errorMsg}</p>}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Current Location</p>
                            <div className="flex">
                                <ClassetInputText
                                    width={250}
                                    className="add-vehicle-field-input w-full"
                                    value={enrollment.currentLocation}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'currentLocation', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations');
                                    }}
                                    placeholder="Enter Current Location"
                                />
                            </div>
                            {formValidations && !formValidations.fields['currentLocation']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['currentLocation']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2"> */}
                        <div className="">
                            <p className="transport-fee-form-label">Identification Marks<span className='ma-required'>*</span></p>
                            <div className="flex">
                                <ClassetTextArea
                                    width={680}

                                    placeholder="Enter Identification Marks"
                                    className="add-vehicle-field-input w-full"
                                    // style={{ width: '100%' }} // Ensure full width
                                    value={enrollment.identificationMarks}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'identificationMarks',
                                            this,
                                            formFields,
                                            enrollment,
                                            formValidations,
                                            'enrollment',
                                            'formValidations'
                                        )
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['identificationMarks']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['identificationMarks']?.errorMsg}</p>
                            )}
                        </div>
                        {/* </div> */}
                    </div>

                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-1 ' style={{ color: 'black' }}>
                            <u>Parent Details</u>
                        </h1>
                    </div>
                    <br />

                    {/* // Update the Parent Details section in the render method */}
                    {this.state.parents.map((parent, index) => (
                        <div key={index} className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Relationship<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.parentType}
                                        options={this.state.parentTypes}

                                        // onChange={(e) => this.onParentChange(e.target.value, index, 'relationship')}
                                        onChange={(e) => { this.onParentChange(e.target.value, index, 'parentType', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations') }}

                                        placeholder='Relationship'
                                    />

                                </div>
                                {/* {enrollment.parentType = this.state.parents[0].parentType} */}
                                {formValidations && !formValidations.fields?.['']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['']?.errorMsg}</p>}

                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Parent Name<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.parentName}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentName')}
                                        placeholder="Enter Parent Name"
                                    />

                                </div>
                                {/* {enrollment.parentName = this.state.parents[0].parentName} */}
                                {formValidations && !formValidations.fields?.['parentName']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['parentName']?.errorMsg}</p>}

                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Qualification<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.qualification}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'qualification')}
                                        placeholder="Enter Qualification"
                                    // keyfilter='alpha'
                                    />
                                </div>
                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Profession<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.profession}

                                        onChange={(e) => this.onParentChange(e.target.value, index, 'profession')}
                                        placeholder="Enter Profession"
                                    // keyfilter='alpha'

                                    />
                                </div>
                            </div>



                            {/* // Also update the Parent Details section to use the same JSON data */}
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.countryCode}
                                        options={this.state.countryPhoneCodes} // This also uses JSON data now
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'countryCode')}
                                        placeholder='Select Country Phone Code'
                                    />
                                </div>
                                {formValidations && !formValidations.fields?.['']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['']?.errorMsg}</p>}
                            </div>

                            {/* Fix: Use parent-specific contact number */}
                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Contact No.<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        keyfilter='int'
                                        maxLength={10}
                                        className=' add-vehicle-field-input w-full '
                                        value={parent.parentContact} // Changed from enrollment.parentContact to parent.contact
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentContact')} // Updated to use parent-specific handler
                                        placeholder="Contact No. (10 digits)"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentContact && !this.state.parentValidations[index]?.parentContact?.isValid && (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentContact?.errorMsg}</p>
                                )}
                            </div>

                            {/* Fix: Use parent-specific email */}
                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Email ID<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='  add-vehicle-field-input w-full '
                                        value={parent.parentEmailId} // Changed from enrollment.parentEmailId to parent.email
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentEmailId')} // Updated to use parent-specific handler
                                        placeholder="Parent/Guardian Email ID"
                                    />
                                </div>
                                {/* {enrollment.parentEmailId = this.state.parents[0].parentEmailId} */}
                                {this.state.parentValidations[index]?.parentEmailId && !this.state.parentValidations[index]?.parentEmailId?.isValid && (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentEmailId?.errorMsg}</p>
                                )}
                            </div>

                            <div className="col-span-1 flex align-items-center">
                                <Button icon="pi pi-plus" aria-label="Add Parent" onClick={() => this.addParent()} style={{ marginRight: '5px' }} />
                                {this.state.parents.length > 1 && (
                                    <Button icon="pi pi-minus" aria-label="Remove Parent" onClick={() => this.removeParent(index)} />
                                )}
                            </div>
                        </div>
                    ))}

                    {/* Remarks */}
                    <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2">
                        <div className="" >
                            <p className="transport-fee-form-label">Remarks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    placeholder='Remarks'
                                    className=""
                                    width={680}
                                    value={enrollment.remarks}
                                    onChange={(e) => onTextChange(e.target.value, 'remarks', this, formFields, enrollment, formValidations, 'enrollment', 'formValidations')}
                                />
                            </div>
                            {formValidations && !formValidations.fields?.['remarks']?.isValid && <p className="p-error text-lg">{formValidations.fields?.['remarks']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* SIBLINGS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Siblings</u>
                        </h1>
                    </div>
                    <br />
                    <div className='p-grid ma-w100p mx-5 ma-p20 mb-5'>
                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.siblings}>
                            <Column header='Sl.No' className='ma-w100 ma-h100' body={(rowData, index) => {
                                return (<span>{index.rowIndex + 1}</span>)
                            }} />
                            <Column header="Name" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        value={this.state.siblings[index.rowIndex].name}
                                        width={250}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "name", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="Gender" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.genderData} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].gender}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "gender", "siblings")}
                                        placeholder="Select Gender" />
                                )
                            }} />
                            <Column header="Class Studying" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.classStudyingDrp} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].classStudying}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "classStudying", "siblings")}
                                        placeholder="Select Class" />
                                )
                            }} />
                            <Column header="School Studying" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].schoolStudying}
                                        placeholder="Enter School Studying"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "schoolStudying", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="" body={(rowData, index) => {
                                return (
                                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                                        <Button icon="pi pi-plus" aria-label="Increase" onClick={() => this.onCliclAddSibling(true, index.rowIndex)} />
                                        {this.state.siblings.length > 1 && <Button icon="pi pi-minus" aria-label="Decrease" onClick={() => this.onCliclAddSibling(false, index.rowIndex)} />}
                                    </div>
                                )
                            }} />
                        </DataTable>
                    </div>

                    {/* ADDRESS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black ' style={{ color: 'black' }}>
                            <u>Address</u>
                        </h1>
                    </div>
                    {/* <br /> */}
                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* Address Line */}
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Address Line<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    width={1300}
                                    // style={{ width: '100vw' }} // Updated to use 100%
                                    className="add-vehicle-field-input w-full"
                                    value={enrollment.addressLine}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'addressLine',
                                            this,
                                            formFields,
                                            enrollment,
                                            formValidations,
                                            'enrollment',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Enter Address Line"
                                />
                            </div>
                            {formValidations && !formValidations.fields['addressLine']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['addressLine']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    {/* state, district, pincode */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Pincode<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.pinCode}
                                    width={250}
                                    onChange={(e) => this.onPincodeChange(e.target.value)}
                                    placeholder="Enter Pincode (6 digits)"
                                    keyfilter='int'
                                    maxLength={6}

                                />
                            </div>
                            {formValidations && !formValidations.fields['pinCode']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['pinCode']?.errorMsg}</p>
                            )}
                        </div>

                        <div className="col-span-1  ">
                            <p className='transport-fee-form-label'>State<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.state}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.state} // Add the options from state
                                    onChange={(e) => this.onStateChange(e.target.value)}
                                    placeholder="Select State"
                                />
                            </div>
                            {formValidations && !formValidations.fields['state']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['state']?.errorMsg}</p>
                            )}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>City/District<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={enrollment.cityOrDist}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.cityOrDist} // Add the options from state
                                    onChange={(e) =>
                                        onDropDownChange(
                                            e.target.value,
                                            'cityOrDist',
                                            this,
                                            formFields,
                                            enrollment,
                                            formValidations,
                                            'enrollment',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Select City/District"
                                />
                            </div>
                            {formValidations && !formValidations.fields['cityOrDist']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['cityOrDist']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">

                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* Transport Required Checkbox */}
                        <div className="col-span-1 flex align-items-center">
                            <input
                                type="checkbox"
                                id="transportRequired"
                                checked={!!enrollment.transportRequired}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    this.setState({
                                        enrollment: {
                                            ...enrollment,
                                            transportRequired: checked,
                                            requestedStop: checked ? enrollment.requestedStop : '' // Clear requestedStop if unchecked
                                        }
                                    });
                                    // Clear validation error for requestedStop when unchecked
                                    if (!checked) {
                                        this.setState(prevState => ({
                                            formValidations: {
                                                ...prevState.formValidations,
                                                fields: {
                                                    ...prevState.formValidations.fields,
                                                    requestedStop: {
                                                        isValid: true,
                                                        errorMsg: ''
                                                    }
                                                }
                                            }
                                        }));
                                    }
                                }}
                                style={{ width: 18, height: 18, marginRight: 8 }}
                            />
                            <label htmlFor="transportRequired" className='transport-fee-form-label'>Transport Required</label>
                        </div>


                    </div>

                    {/* Conditionally Render Requested Stop Dropdown */}
                    {enrollment.transportRequired && (
                        // ...existing code...

                        <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="">
                                <p className='transport-fee-form-label'>Requested Stop<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={enrollment.requestedStop}
                                        onChange={(e) =>
                                            onTextChange(
                                                e.target.value,
                                                'requestedStop',
                                                this,
                                                formFields,
                                                enrollment,
                                                formValidations,
                                                'enrollment',
                                                'formValidations'
                                            )
                                        }
                                        placeholder='Enter Requested Stop'
                                    />
                                </div>
                                {formValidations && !formValidations.fields['requestedStop']?.isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['requestedStop']?.errorMsg}</p>
                                )}
                            </div>
                        </div>

                        // ...existing code...
                    )}

                    <div className="text-center mt-8">

                        {this.state.isEnrollmentFeePaid && (
                            <Button
                                // icon={'pi pi-save text-lg'} 
                                label={this.state.isEdit ? 'Save ' : 'Save '}
                                onClick={this.onSaveEnrollment}
                                className="add-vehicle-btn"

                                // className='confirmDialogAcceptBtn mr-3 w-18rem p-3'
                                // style={{ backgroundColor: '#076EFF', border: 'none' }}
                                style={{ marginRight: '10px' }}

                            />
                        )}
                        <Button
                            label="Next"
                            // style={{ backgroundColor: '#268900', borderColor: '#268900' }}
                            disabled={this.state.isShowPayFeeButton && !this.state.isEnrollmentFeePaid}
                            onClick={() => {
                                // Check all required fields first
                                const missingFields = this.validateRequiredFields();

                                if (missingFields.length > 0) {
                                    // Show detailed error message with first 5 missing fields
                                    const fieldsToShow = missingFields.slice(0, 5);
                                    const remainingCount = missingFields.length - fieldsToShow.length;
                                    const detailMessage = remainingCount > 0
                                        ? `${fieldsToShow.join(', ')} and ${remainingCount} more field(s)`
                                        : fieldsToShow.join(', ');

                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Required Fields Missing',
                                        detail: `Please fill the following required fields: ${detailMessage}`,
                                        life: 5000
                                    });
                                    return;
                                }

                                if (this.state.registration?.transport && this.state?.requestedStop == "") {
                                    this.toast.show({ severity: 'error', summary: 'Please Select Requested Stop', detail: 'Please Select Requested Stop', life: 3000 });
                                    return
                                }
                                const { enrollment } = this.state
                                const newReg = { ...enrollment, parentDetails: this.state.parentDetails }
                                console.log(newReg);
                                let enrollmentData = { ...enrollment }
                                enrollment.siblings = this.state.siblings
                                enrollment.prevAcademicDetails = this.state.prevAcademicDetails
                                enrollment.studentPhoto = enrollment?.studentPhoto || enrollment?.application?.studentPhoto
                                // enrollment.houseNum = enrollment?.houseNum || enrollment?.application?.houseNum;
                                enrollment.pinCode = enrollment?.pinCode || enrollment?.application?.pinCode;
                                // enrollment.streetOrVillage = enrollment?.streetOrVillage || enrollment?.application?.streetOrVillage;
                                // enrollment.mandal = enrollment?.mandal || enrollment?.application?.mandal;
                                enrollment.cityOrDist = enrollment?.cityOrDist || enrollment?.application?.cityOrDist;
                                enrollment.state = enrollment?.state || enrollment?.application?.state;
                                const formStatus = isFormValid(createEnrollmentFields, this.formFields.formValidations, trimObj(enrollment));
                                let isCompleteFormValid = true;
                                if (!formStatus.formValidations.isFormValid) {
                                    this.setState({
                                        formValidations: formStatus.formValidations,
                                    });
                                    isCompleteFormValid = false;
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Validation Error',
                                        detail: 'Please fill all required fields correctly',
                                        life: 3000
                                    });
                                }


                                let slectedTransportInfo = []
                                if (enrollment?.transport) {
                                    const { routesList } = this.state
                                    slectedTransportInfo = routesList?.filter(el => el.stopId === this.state?.requestedStop)
                                }
                                const academicSession = localStorage.getItem('userAcademicYear')
                                if (isCompleteFormValid) {
                                    let payload = {
                                        "sid": "enrollment-sid",
                                        enrollmentData: enrollmentData,
                                        stage: "Enrollment",
                                        _id: enrollment?._id,

                                        // Academic Information
                                        academicSession: academicSession,
                                        academicCategory: enrollment?.academicCategory || enrollment?.enquiry?.academicCategory,
                                        categoryName: enrollment?.admissionCategoryName || enrollment?.enquiry?.admissionCategoryName,
                                        branch: enrollment?.branch,
                                        branchName: enrollment?.branchName,
                                        board: enrollment?.board,
                                        boardName: enrollment?.boardName,
                                        grade: enrollment?.grade,
                                        gradeName: enrollment?.gradeName,
                                        groupId: enrollment?.groupId,

                                        // Application/Enrollment IDs
                                        applicationId: enrollment?.applicationId,

                                        // Student Personal Information
                                        firstName: enrollment?.firstName,
                                        middleName: enrollment?.middleName,
                                        lastName: enrollment?.lastName,
                                        gender: enrollment?.gender,
                                        dob: enrollment?.dob,

                                        // Student Contact
                                        stdCountryCode: enrollment?.stdCountryCode,
                                        stdContactNo: enrollment?.stdContactNo,
                                        stdEmailId: enrollment?.stdEmailId,
                                        contactNo: enrollment?.contactNo,
                                        emailId: enrollment?.emailId,

                                        // Identity Information
                                        nationality: enrollment?.nationality,
                                        govtIdType: enrollment?.govtIdType,
                                        idDetails: enrollment?.idDetails,
                                        aadharNo: enrollment?.aadharNo,
                                        identificationMarks: enrollment?.identificationMarks,

                                        // Cultural Information
                                        religion: enrollment?.religion,
                                        motherTongue: enrollment?.motherTongue,
                                        caste: enrollment?.caste,

                                        // Previous School
                                        previousSchool: enrollment?.previousSchool,
                                        previousBoard: enrollment?.previousBoard,
                                        previousGrade: enrollment?.previousGrade,

                                        // Address Information
                                        currentLocation: enrollment?.currentLocation,
                                        addressLine: enrollment?.addressLine,
                                        pinCode: enrollment?.pinCode,
                                        cityOrDist: enrollment?.cityOrDist,
                                        state: enrollment?.state,

                                        // Parent Information
                                        parentName: enrollment?.parentName,
                                        parentType: enrollment?.parentType,
                                        parentContact: enrollment?.parentContact,
                                        parentEmailId: enrollment?.parentEmailId,
                                        parentQualification: enrollment?.parentQualification,
                                        occupation: enrollment?.occupation,
                                        countryCode: enrollment?.countryCode,
                                        parentDetails: this.state.parentDetails,

                                        // Family Information
                                        parents: this.state.parents || enrollment?.parents,
                                        siblings: enrollment?.siblings || this.state.siblings,

                                        // Transport Information
                                        transportRequired: enrollment?.transportRequired || enrollment?.transport || false,
                                        requestedStop: this.state.requestedStop || enrollment?.requestedStop || "",
                                        transportInfo: slectedTransportInfo?.length && slectedTransportInfo[0],

                                        // Documents
                                        studentPhoto: enrollment?.studentPhoto,

                                        // Fee Information
                                        feeStructure: this.state.selectedFeeStructure,

                                        // Additional Information
                                        admissionTest: enrollment?.admissionTest,
                                        remarks: enrollment?.remarks,
                                        customFields: enrollment?.customFields || [],

                                        // Academic History
                                        prevAcademicDetails: enrollment?.prevAcademicDetails

                                    }
                                    this.setState({
                                        isLoading: true
                                    });
                                    // if (isNext) {
                                    //     payload.stage = "Enrollment"
                                    // }

                                    const url = `${baseUrlAdmin}/admissions/add-enrollment`;
                                    this.service.post(url, payload, true)
                                        .then(res => {
                                            if (res && res.status && res.res.status) {
                                                this.setState({
                                                    isLoading: false,
                                                    createdId: res?.res?.message,
                                                },
                                                    () => { console.log("passing for enrollment") }
                                                    //  () => { this.onHandleNavigate(isContinue, isNext) }
                                                );
                                                // this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

                                            } else {
                                                this.setState({
                                                    isLoading: false
                                                });
                                                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                                            }
                                        }).catch(e => {
                                            this.setState({
                                                isLoading: false
                                            });
                                            this.toast.show({ severity: 'error', summary: "Error", detail: 'Some error occurred', life: 3000 });
                                            console.log(e);
                                        })

                                } else {
                                    this.setState({
                                        isLoading: false
                                    });
                                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Some error occurred', life: 3000 });
                                }

                                // }
                                this.previewConfirmEnrollment();
                            }
                            }
                            className="confirmDialogAcceptBtn  mr-5 w-18rem p-5"
                        />

                        <Button
                            label="Reject"
                            onClick={() => {
                                this.onHandleReject();
                            }}
                            // className="confirmDialogAcceptBtn  mr-5 w-18rem p-5"
                            className="p-5 mr-5"
                            style={{
                                backgroundColor: '#BF0031', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px',
                            }}
                        />

                        <Button
                            label="Cancel"
                            className="confirmDialogCancelBtn p-5"
                            style={{
                                background: '#E6E8EA', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px', color: 'black'
                            }}
                            onClick={() => {
                                localStorage.removeItem('applicationId')
                                if (!this.state?.viewEnrollment) {
                                    this.props.navigate('/admission-enrollment');
                                } else {
                                    this.setState({ viewEnrollment: false }, () => {
                                        this.props.navigate('/admission-enrollment');
                                    });
                                }
                            }}

                        // onClick={() => (!this.state?.viewEnrollment ? this.props.navigate('/admission-enrollment') : this.setState({ viewEnrollment: false }, () => this.props.navigate('/admission-enrollment')))}
                        />
                    </div>


                </div >
                {/* {
                    this.state.isLoading && <>
                        <LoadingComponent />
                } */}
                <SafeToast ref={this.safeToast} position="bottom-right" />
                {/* Keeping the old Toast reference for backward compatibility */}
                <Toast ref={(el) => {
                    // Only update if it's a valid reference
                    if (el && typeof el.show === 'function') {
                        this.toast = el;
                    }
                }} style={{ display: 'none' }} position="bottom-right" />

                {/* {this.state.showNTTPayment && this.state.nttPaymentData && ( */}
                <NTTPaymentComponent
                    showPaymentButton={this.state.showNTTPayment}

                    paymentData={this.state.nttPaymentData}
                    onPaymentSuccess={this.onNTTPaymentSuccess}
                    onPaymentError={this.onNTTPaymentError}
                    onPaymentCancel={this.onNTTPaymentCancel}
                />
                {/* )} */}

                <Dialog
                    isopen={this.state.isOpenPayFeeDailog}
                    visible={this.state.isOpenPayFeeDailog}
                    className="pay-fee"
                    style={{ position: 'fixed', right: '0' }}
                    draggable={false}
                    onHide={this.onHandleCancelPayFee}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Pay Fee</h3>
                            </div>
                        );
                    }}
                >
                    <div className="mb-5 ml-5 mr-5">
                        <div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id="term"
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Type name"
                                        disabled={true}
                                        value={`${this.state.feePayInfo?.feeName || ''}`}
                                        onChange={(e) => onTextChange(e.target.value, 'FeeTypeName', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                    />
                                </div>
                                {/* {payFormValidations && !payformValidations.fields?.['']?.isValid && <p className="p-error">{payformValidations.fields?.['']?.errorMsg}</p>} */}
                            </div>

                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id="feeAmount"
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Amount"
                                        disabled={true}
                                        value={`${Number(this.state.feePayInfo?.amount) || 0}`}
                                        onChange={(e) => onTextChange(e.target.value, 'feeAmount', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                    />
                                </div>
                                {/* {payFormValidations && !payformValidations.fields?.['']?.isValid && <p className="p-error">{payformValidations.fields?.['']?.errorMsg}</p>} */}
                            </div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetDropdown
                                        id="paymentType"
                                        className=""
                                        height="48px"
                                        width="368px"
                                        options={this.state?.paymentModes}
                                        value={payFeeFormData?.paymentType}
                                        onChange={(e) => {
                                            onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations);
                                        }}
                                        placeholder={
                                            <div>
                                                <span className="">Payment Type</span>
                                            </div>
                                        }
                                    />
                                </div>
                                {/* {payFormValidations && !payformValidations.fields?.['']?.isValid && <p className="p-error">{payformValidations.fields?.['']?.errorMsg}</p>} */}
                            </div>
                            {(
                                // payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                                payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f'
                                // payFeeFormData.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
                            ) && (
                                    <div className="col-12">
                                        <label className="label mb-2 ">
                                            Transaction Id<span className="ma-required">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText className="" height="48px" width="368px" placeholder="Enter Transaction Id" value={this.state?.transctionId} onChange={(e) => this.setState({ transctionId: e.target.value })} />
                                        </div>
                                    </div>
                                )}
                            {payFeeFormData.paymentType && (
                                <div className="col-12">
                                    <label className="label mb-2 ">
                                        Remarks<span className="ma-required"></span>
                                    </label>
                                    <div className="mt-2">
                                        <ClassetTextArea
                                            id="feeType"
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Remarks"
                                            value={payFeeFormData.remarks}
                                            onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="flex justify-content-center mb-4 mt-4">
                                <Button className="formSubmitButtonn mr-2" style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                    // onClick={this.OnPayFee}
                                    onClick={this.handlePayment}
                                >
                                    <AddIcon2 />
                                    <p className="formSubmitButtonnText">Pay Now</p>
                                </Button>
                                <Button className="cancelButtonn w-4" onClick={this.onHandleCancelPayFee}>
                                    <p className="cancelButtonnText ">Cancel</p>
                                </Button>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.isRaiseDialogOpen}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Student Enrollment </p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }}
                                onClick={() => {
                                    this.onRejectUser();
                                }}
                            >
                                <p className="formSubmitButtonText">Reject</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0, borderRadius: '8px' }} onClick={() => this.setState({ isRaiseDialogOpen: false, remarks: '' })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRaiseDialogOpen: false })}
                >
                    <div className=" m-3 pt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <div className="">
                            <ClassetTextArea width={'100%'} style={{ height: '119px' }} label={'Remarks:'} placeholder="Remarks" value={this.state.remarks} onChange={(e) => this.setState({ remarks: e.target.value })} />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.isCloseOfFeeStructure}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Canceling this will leave the fee assignment incomplete for the student. Do you want to proceed?</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button className="formSubmitButton px-4" style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }} onClick={() => this.showConfirmDialog()}>
                                <p className="formSubmitButtonText">Confirm</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isCloseOfFeeStructure: false, remarks: '' })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isCloseOfFeeStructure: false })}
                ></Dialog>



                <Dialog
                    isOpen={this.state.isShowFeeStructure}
                    visible={this.state.isShowFeeStructure}
                    style={this.state.isFeeDialogMaximized ? { width: '95vw', height: '95vh' } : { width: '75vw', height: '80vh' }}
                    draggable={false}
                    onHide={() => this.onCloseOfFeeStructure()}
                    closable={true}
                    maximizable={false}
                    header={() => {
                        return (
                            <div className="p-2">
                                <div className="flex justify-content-between align-items-center">
                                    <h3 className="text-center formhead flex-grow-1 m-0">Student Enrollment Confirmed - Assign Fee Schedule</h3>
                                    <Button
                                        icon={this.state.isFeeDialogMaximized ? "pi pi-window-minimize" : "pi pi-window-maximize"}
                                        className="p-button-rounded p-button-text p-button-plain"
                                        onClick={() => this.setState({ isFeeDialogMaximized: !this.state.isFeeDialogMaximized })}
                                        tooltip={this.state.isFeeDialogMaximized ? "Minimize" : "Maximize"}
                                        tooltipOptions={{ position: 'bottom' }}
                                        style={{ marginRight: '40px' }}
                                    />
                                </div>
                                {/* <h3 className="text-center formhead visually-hidden">Student Enrollment Confirmed - Assign Fee Schedule</h3> */}
                                {this.state?.userCreatedInfo && (
                                    <>
                                        <div className="flex flex-column align-items-center justify-content-center">
                                            <p>
                                                <span className="enrolledDataHeaders">Enrollment Id :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.enrollmentId}</span>
                                            </p>
                                            <p>
                                                <span className="enrolledDataHeaders">Branch :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.user_info?.branchName}</span>
                                            </p>
                                            <p>
                                                <span className="enrolledDataHeaders">Grade :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.user_info?.['custom:grade']}</span>
                                            </p>
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center p-3" style={{ borderTop: '1px solid #dee2e6' }}>
                            <Button
                                label="Assign"
                                className="p-button-primary submitButtonn mr-4 button text-lg "
                                style={{ width: "150px" }}
                                onClick={() => this.feeStructureAssign(true)}
                                disabled={this.state.isRegularFeeStructureAssigned}
                            />
                            {!this.state.isRegularFeeStructureAssigned && (
                                <Button
                                    className="cancelButtonn w-1 mr-4"
                                    onClick={() => this.onCloseOfFeeStructure()}
                                >
                                    <p className="cancelButtonnText">Cancel</p>
                                </Button>
                            )}
                            {this.state.isRegularFeeStructureAssigned && (
                                <Button
                                    label="View Student Details"
                                    className="p-button-primary submitButtonn mr-4 button text-lg "
                                    disabled={!this.state?.isRegularFeeStructureAssigned || (this.state?.isOptedForTransport && !this.state?.isFeeStructureAssigned)}
                                    onClick={() => {
                                        if (this.state?.isRegularFeeStructureAssigned || (this.state?.isOptedForTransport && this.state?.isFeeStructureAssigned)) {
                                            this.showConfirmDialog();
                                        }
                                    }}
                                />
                            )}
                        </div>
                    )}
                >
                    <div className="mb-5 ml-5 mr-5 p-2" style={{ maxHeight: 'calc(95vh - 250px)', overflowY: 'auto' }}>
                        <div className="flex ">
                            <div className=" ">
                                <label className="label">
                                    Fee Schedule<span className="ma-required">*</span>
                                </label>
                                <div className='flex'>
                                    <div className="mt-3">
                                        <ClassetDropdown
                                            options={this.state.feeStructureR}
                                            optionLabel="feeStructureName"
                                            optionValue="id"
                                            width={250}
                                            filter
                                            showClear
                                            filterBy="feeStructureName"
                                            value={this.state.selectedRFeeStructure}
                                            onChange={(e) => this.setState({ selectedRFeeStructure: e.target.value }, () => this.getSelectedFeeStructure(this.state.selectedRFeeStructure, true))}
                                            placeholder="Select Fee Schedule"
                                            disabled={this.state.isRegularFeeStructureAssigned}
                                        />
                                    </div>
                                    {this.state.selectedRFeeStructure && (
                                        <div className="mt-3 p-3" style={{
                                            backgroundColor: '#FEF3C7',
                                            border: '1px solid #FCD34D',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '10px',
                                            marginLeft: '10px'
                                        }}>
                                            <i className="pi pi-info-circle" style={{
                                                color: '#D97706',
                                                fontSize: '18px',
                                                marginTop: '2px'
                                            }}></i>
                                            <div style={{ flex: 1 }}>
                                                <p className="m-0" style={{
                                                    color: '#92400E',
                                                    fontSize: '14px',
                                                    lineHeight: '1.5',
                                                    fontWeight: '500'
                                                }}>
                                                    Below fees and installments correspond to the selected Fee Schedule; upon assignment, the student will be enrolled with fees based on their Admission Type.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>


                        {this.state.canShowTransport && (
                            <div className="grid mb-3 ml-1 mt-2">
                                <div className="col-4">
                                    <div className="flex column-gap-8 ">
                                        <label className="label">
                                            Transport<span className="ma-required">*</span>
                                        </label>
                                        <InputSwitch checked={this.state.isOptedForTransport} onChange={(e) => this.onToggleChange(e, 'transport')} />
                                    </div>
                                    <div className="col-span-1 ">
                                        {/* <p className='transport-fee-form-label'>Requested Stop<span className='ma-required'>*</span></p> */}
                                        <div className="flex">
                                            <ClassetDropdown
                                                filter
                                                showClear
                                                filterBy="label"
                                                options={this.state.routesList}
                                                optionLabel="label"
                                                optionValue="stopId"
                                                width={250}
                                                value={this.state.requestedStop}
                                                onChange={(e) => this.setState({ requestedStop: e.target.value })}
                                                placeholder="Enter Requested Stop"
                                                disabled={!this.state.isOptedForTransport ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4 ">
                                    <label className="label">
                                        Transport Fee Schedule<span className="ma-required">*</span>
                                    </label>
                                    <div className="mt-4">
                                        <ClassetDropdown
                                            options={this.state.feeStructure}
                                            optionLabel="scheduleName"
                                            optionValue="_id"
                                            width={250}
                                            value={this.state.selectedFeeStructure}
                                            onChange={(e) => this.setState({ selectedFeeStructure: e.target.value }, () => this.getSelectedFeeStructure(this.state.selectedFeeStructure, false))}
                                            placeholder="Enter Fee Schedule"
                                        />
                                    </div>
                                </div>
                                <div className="col-4 mt-5 ">
                                    <label className="label"></label>
                                    <Button label="Assign" className="p-button-primary mt-3 button-style mr-4 button text-lg "
                                        disabled={!this.state?.isRegularFeeStructureAssigned || (!this.state?.isOptedForTransport && !this.state?.isFeeStructureAssigned)}
                                        onClick={this.onAssignTransportFee} />
                                </div>
                            </div>
                        )}

                        {/* Fee Schedule Preview - Similar to Fee Setup View */}
                        {this.state?.regularFeeStructureDetails && this.state?.regularFeeStructureDetails?.stepTwo && (
                            <div className="mt-4 p-3">
                                {/* Fee Schedule Summary */}
                                <div className="mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                    <h4 className="text-xl font-semibold mb-3">Fee Schedule Summary</h4>
                                    <div className="grid">
                                        <div className="col-4">
                                            <p><strong>Total Fee Types:</strong> {this.state?.regularFeeStructureDetails?.stepOne?.length || 0}</p>
                                        </div>
                                        <div className="col-4">
                                            <p><strong>Total Amount:</strong> ₹{this.state?.regularFeeStructureDetails?.stepOne?.reduce((sum, fee) => sum + (parseFloat(fee.totalFee) || 0), 0).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* One-time Fees Section */}
                                {this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => fee.isOneTime)?.length > 0 && (
                                    <div className="mb-4">
                                        <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                                        <DataTable
                                            value={this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => fee.isOneTime).sort((a, b) => (a.priority || 999) - (b.priority || 999))}
                                            responsiveLayout="scroll"
                                        >
                                            <Column
                                                header="Priority"
                                                body={(rowData, index) => index.rowIndex + 1}
                                                style={{ width: '80px' }}
                                            />
                                            <Column field="feeType" header="Fee Type" />
                                            <Column
                                                field="totalFee"
                                                header="Amount"
                                                body={(rowData) => `₹${parseFloat(rowData.totalFee || 0).toFixed(2)}`}
                                            />
                                            <Column
                                                header="Due Date"
                                                body={(rowData) => (
                                                    <span>{rowData.dueDate ? moment(rowData.dueDate).format('DD/MM/YYYY') : 'Not set'}</span>
                                                )}
                                            />
                                        </DataTable>
                                    </div>
                                )}

                                {/* Installment-based Fees */}
                                {(() => {
                                    // Group fees by installment
                                    const installmentGroups = {};
                                    this.state?.regularFeeStructureDetails?.stepTwo?.forEach(fee => {
                                        if (!fee.isOneTime && fee.installmentId) {
                                            if (!installmentGroups[fee.installmentId]) {
                                                installmentGroups[fee.installmentId] = [];
                                            }
                                            installmentGroups[fee.installmentId].push(fee);
                                        }
                                    });

                                    return Object.keys(installmentGroups).length > 0 && Object.entries(installmentGroups).map(([installmentId, fees], index) => {
                                        const totalInstallmentAmount = fees.reduce((sum, fee) => sum + (parseFloat(fee.termWiseActualValue) || 0), 0);
                                        const dueDate = fees[0]?.dueDate;

                                        return (
                                            <div key={installmentId} className="mb-4">
                                                <div className="flex align-items-center gap-3 mb-2">
                                                    <h4 className="m-0">
                                                        Installment {index + 1} - {dueDate ? moment(dueDate).format('DD/MM/YYYY') : 'Date not set'}
                                                    </h4>
                                                    <span className="text-primary font-semibold">Total: ₹{totalInstallmentAmount.toFixed(2)}</span>
                                                </div>
                                                <DataTable value={fees.sort((a, b) => (a.priority || 999) - (b.priority || 999))} responsiveLayout="scroll">
                                                    <Column
                                                        header="Priority"
                                                        body={(rowData, index) => index.rowIndex + 1}
                                                        style={{ width: '80px' }}
                                                    />
                                                    <Column field="feeType" header="Fee Type" />
                                                    <Column
                                                        header="Total Fee"
                                                        body={(rowData) => {
                                                            const feeTypeData = this.state?.regularFeeStructureDetails?.stepOne?.find(f => f.feeTypeId === rowData.feeTypeId);
                                                            return `₹${parseFloat(feeTypeData?.totalFee || 0).toFixed(2)}`;
                                                        }}
                                                    />
                                                    <Column
                                                        header="Percentage"
                                                        body={(rowData) => `${parseFloat(rowData.termWisePercentageOrValue || 0).toFixed(2)}%`}
                                                    />
                                                    <Column
                                                        header="Installment Amount"
                                                        body={(rowData) => `₹${parseFloat(rowData.termWiseActualValue || 0).toFixed(2)}`}
                                                    />
                                                </DataTable>
                                            </div>
                                        );
                                    });
                                })()}

                                {/* Non-installment fees (if any) */}
                                {this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => !fee.isOneTime && !fee.installmentId)?.length > 0 && (
                                    <div className="mb-4">
                                        <h4 className="text-xl font-semibold mb-2">Other Fees</h4>
                                        <DataTable
                                            value={this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => !fee.isOneTime && !fee.installmentId).sort((a, b) => (a.priority || 999) - (b.priority || 999))}
                                            responsiveLayout="scroll"
                                        >
                                            <Column
                                                header="Priority"
                                                body={(rowData, index) => index.rowIndex + 1}
                                                style={{ width: '80px' }}
                                            />
                                            <Column field="feeType" header="Fee Type" />
                                            <Column
                                                field="totalFee"
                                                header="Amount"
                                                body={(rowData) => `₹${parseFloat(rowData.totalFee || 0).toFixed(2)}`}
                                            />
                                            <Column
                                                header="Due Date"
                                                body={(rowData) => (
                                                    <span>{rowData.dueDate ? moment(rowData.dueDate).format('DD/MM/YYYY') : 'Not set'}</span>
                                                )}
                                            />
                                        </DataTable>
                                    </div>
                                )}
                            </div>
                        )}

                        {this.state.isLoading && <LoadingComponent />}
                    </div>
                </Dialog>
                <Dialog
                    visible={this.state.isCredeintalsDisplay}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: '520px', maxWidth: '90vw', borderRadius: '16px' }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="text-center pt-4 pb-2">
                                <div className="flex justify-content-center mb-4">
                                    <div style={{
                                        width: '72px',
                                        height: '72px',
                                        borderRadius: '50%',
                                        backgroundColor: '#10B981',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
                                    }}>
                                        <i className="pi pi-check" style={{ fontSize: '36px', color: 'white', fontWeight: 'bold' }}></i>
                                    </div>
                                </div>
                                <h2 style={{
                                    fontWeight: '700',
                                    fontSize: '24px',
                                    color: '#1F2937',
                                    margin: 0,
                                    fontFamily: 'InterSemiBold'
                                }}>Enrollment Confirmed!</h2>
                                <p style={{
                                    color: '#6B7280',
                                    fontSize: '14px',
                                    marginTop: '8px',
                                    fontFamily: 'InterRegular'
                                }}>Student has been successfully enrolled</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center pb-4 pt-2">
                            <Button
                                className="formSubmitButton"
                                style={{
                                    borderRadius: '12px',
                                    backgroundColor: '#076EFF',
                                    border: 'none',
                                    padding: '14px 40px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 8px rgba(7, 110, 255, 0.25)',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() => {
                                    this.setState({ isCredeintalsDisplay: false, studentDetails: true });
                                }}
                            >
                                <span style={{ fontFamily: 'InterSemiBold' }}>View Student Details</span>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isCredeintalsDisplay: false })}
                >
                    <div className="px-4 py-3" style={{ backgroundColor: '#F9FAFB', borderRadius: '12px', margin: '0 24px 24px 24px' }}>
                        {this.state?.userCreatedInfo && (
                            <div className="flex flex-column" style={{ gap: '16px' }}>
                                <div style={{
                                    backgroundColor: 'white',
                                    padding: '16px',
                                    borderRadius: '10px',
                                    border: '1px solid #E5E7EB',
                                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                }}>
                                    <div className="flex align-items-center justify-content-between mb-2">
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#6B7280',
                                            fontWeight: '500',
                                            fontFamily: 'InterMedium',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Enrollment ID</span>
                                    </div>
                                    <div style={{
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        color: '#076EFF',
                                        fontFamily: 'InterBold',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {this.state?.userCreatedInfo?.enrollmentId}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '12px'
                                }}>
                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Branch</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.branchName}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Board</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.['custom:board']}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Grade</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.['custom:grade']}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Section</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.sectionName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.studentDetails}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: '700px', maxWidth: '90vw', borderRadius: '16px' }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="text-center pt-4 pb-3">
                                <div className="flex justify-content-center mb-4">
                                    <div style={{
                                        width: '64px',
                                        height: '64px',
                                        borderRadius: '50%',
                                        backgroundColor: '#EFF6FF',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '3px solid #DBEAFE'
                                    }}>
                                        <i className="pi pi-key" style={{ fontSize: '28px', color: '#076EFF' }}></i>
                                    </div>
                                </div>
                                <h2 style={{
                                    fontWeight: '700',
                                    fontSize: '26px',
                                    lineHeight: '1.3',
                                    color: '#1F2937',
                                    marginBottom: '8px',
                                    fontFamily: 'InterBold'
                                }}>LMS & ERP</h2>
                                <h3 style={{
                                    fontWeight: '600',
                                    fontSize: '22px',
                                    lineHeight: '1.3',
                                    color: '#076EFF',
                                    marginTop: '0',
                                    fontFamily: 'InterSemiBold'
                                }}>Login Credentials</h3>
                                <p style={{
                                    color: '#6B7280',
                                    fontSize: '14px',
                                    marginTop: '8px',
                                    fontFamily: 'InterRegular'
                                }}>Share these credentials with the student and parent</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center pb-4 pt-3" style={{ gap: '12px' }}>
                            <Button
                                icon="pi pi-times"
                                label="Close"
                                className="p-button-outlined"
                                style={{
                                    borderRadius: '12px',
                                    border: '2px solid #E5E7EB',
                                    color: '#6B7280',
                                    backgroundColor: 'white',
                                    padding: '12px 32px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    minWidth: '140px',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() =>
                                    !this.state?.viewEnrollment
                                        ? this.props.navigate('/admission-enrollment')
                                        : this.setState({ viewEnrollment: false, isCredeintalsDisplay: false, studentDetails: false }, () => this.props.navigate('/admission-enrollment'))
                                }
                            />
                        </div>
                    )}
                    onHide={() => this.setState({ studentDetails: false })}
                >
                    <div className="px-4 pb-4" style={{ fontFamily: 'InterRegular' }}>
                        {/* Student Login Credentials Section */}
                        <div className="mb-4">
                            <div style={{
                                backgroundColor: '#F9FAFB',
                                padding: '24px',
                                borderRadius: '12px',
                                border: '1px solid #E5E7EB'
                            }}>
                                <div className="flex align-items-center mb-3" style={{ gap: '10px' }}>
                                    <div style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '8px',
                                        backgroundColor: '#DBEAFE',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <i className="pi pi-user" style={{ fontSize: '18px', color: '#076EFF' }}></i>
                                    </div>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#1F2937',
                                        margin: 0,
                                        fontFamily: 'InterSemiBold'
                                    }}>Student Login</h3>
                                </div>

                                {this.state?.userCreatedInfo && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '20px' }}>
                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: '16px 20px',
                                            borderRadius: '10px',
                                            border: '1px solid #E5E7EB',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                        }}>
                                            <div className="flex align-items-center justify-content-between">
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#9CA3AF',
                                                        marginBottom: '6px',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        fontFamily: 'InterMedium'
                                                    }}>Username</div>
                                                    <div style={{
                                                        fontSize: '18px',
                                                        fontWeight: '600',
                                                        color: '#1F2937',
                                                        fontFamily: 'InterSemiBold',
                                                        letterSpacing: '0.3px'
                                                    }}>
                                                        {this.state?.userCreatedInfo?.user_info?.username ? this.state.userCreatedInfo.user_info.username.slice(3) : ''}
                                                    </div>
                                                </div>
                                                <Button
                                                    icon="pi pi-copy"
                                                    className="p-button-rounded p-button-text"
                                                    style={{ color: '#076EFF' }}
                                                    onClick={() => {
                                                        const username = this.state?.userCreatedInfo?.user_info?.username ? this.state.userCreatedInfo.user_info.username.slice(3) : '';
                                                        navigator.clipboard.writeText(username);
                                                    }}
                                                    tooltip="Copy username"
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: '16px 20px',
                                            borderRadius: '10px',
                                            border: '1px solid #E5E7EB',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                        }}>
                                            <div className="flex align-items-center justify-content-between">
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#9CA3AF',
                                                        marginBottom: '6px',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        fontFamily: 'InterMedium'
                                                    }}>Password</div>
                                                    <div style={{
                                                        fontSize: '18px',
                                                        fontWeight: '600',
                                                        color: '#1F2937',
                                                        fontFamily: 'InterSemiBold',
                                                        letterSpacing: '0.5px'
                                                    }}>
                                                        {(() => {
                                                            const lastName = this.state?.userCreatedInfo?.user_info?.lastName || '';
                                                            const dob = this.state?.userCreatedInfo?.user_info?.dateOfBirth;

                                                            if (!lastName || !dob) return 'Not available';

                                                            const cleanedLastName = lastName.trim().replace(/\s+/g, '');
                                                            const surname4Chars = cleanedLastName
                                                                ? cleanedLastName.slice(0, 4).charAt(0).toUpperCase() + cleanedLastName.slice(1, 4).toLowerCase()
                                                                : '';

                                                            const date = new Date(dob);
                                                            const dd = String(date.getDate()).padStart(2, '0');
                                                            const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                            const yyyy = date.getFullYear();

                                                            return `${surname4Chars}@${dd}${mm}${yyyy}`;
                                                        })()}
                                                    </div>
                                                </div>
                                                <Button
                                                    icon="pi pi-copy"
                                                    className="p-button-rounded p-button-text"
                                                    style={{ color: '#076EFF' }}
                                                    onClick={() => {
                                                        const lastName = this.state?.userCreatedInfo?.user_info?.lastName || '';
                                                        const dob = this.state?.userCreatedInfo?.user_info?.dateOfBirth;
                                                        if (lastName && dob) {
                                                            const cleanedLastName = lastName.trim().replace(/\s+/g, '');
                                                            const surname4Chars = cleanedLastName
                                                                ? cleanedLastName.slice(0, 4).charAt(0).toUpperCase() + cleanedLastName.slice(1, 4).toLowerCase()
                                                                : '';
                                                            const date = new Date(dob);
                                                            const dd = String(date.getDate()).padStart(2, '0');
                                                            const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                            const yyyy = date.getFullYear();
                                                            const password = `${surname4Chars}@${dd}${mm}${yyyy}`;
                                                            navigator.clipboard.writeText(password);
                                                        }
                                                    }}
                                                    tooltip="Copy password"
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Parent Mobile App Login Section */}
                        {this.state?.userCreatedInfo?.user_info?.parentContactNo && (
                            <div>
                                <div style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    padding: '24px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                                }}>
                                    <div className="flex align-items-center mb-3" style={{ gap: '10px' }}>
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '8px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="pi pi-mobile" style={{ fontSize: '18px', color: 'white' }}></i>
                                        </div>
                                        <h3 style={{
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            color: 'white',
                                            margin: 0,
                                            fontFamily: 'InterSemiBold'
                                        }}>Parent Mobile App</h3>
                                    </div>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: '14px',
                                        marginBottom: '16px',
                                        fontFamily: 'InterRegular',
                                        lineHeight: '1.6'
                                    }}>
                                        Parents can download the mobile app and login using their registered contact number
                                    </p>
                                    <div style={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                        backdropFilter: 'blur(10px)',
                                        padding: '16px 20px',
                                        borderRadius: '10px',
                                        border: '1px solid rgba(255, 255, 255, 0.2)'
                                    }}>
                                        <div className="flex align-items-center justify-content-between">
                                            <div>
                                                <div style={{
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    marginBottom: '6px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    fontFamily: 'InterMedium'
                                                }}>Contact Number</div>
                                                <div style={{
                                                    fontSize: '20px',
                                                    fontWeight: '700',
                                                    color: 'white',
                                                    fontFamily: 'InterBold',
                                                    letterSpacing: '1px'
                                                }}>
                                                    {this.state?.userCreatedInfo?.user_info?.parentContactNo}
                                                </div>
                                            </div>
                                            <Button
                                                icon="pi pi-copy"
                                                className="p-button-rounded"
                                                style={{
                                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                    border: 'none',
                                                    color: 'white'
                                                }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(this.state?.userCreatedInfo?.user_info?.parentContactNo);
                                                }}
                                                tooltip="Copy number"
                                                tooltipOptions={{ position: 'top' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>
                {this.state.isShowReceipt && (
                    <FeeReciept
                        receiptData={this.state?.receiptData}
                        hideFeeReciept={() => {
                            this.setState({
                                isShowReceipt: false,
                                receiptData: {}
                            });
                        }}
                    />
                )}
                {this.state.isLoading && (
                    <>
                        <LoadingComponent />
                    </>
                )}

                <Toast ref={(el) => {
                    // Only update if it's a valid reference
                    if (el && typeof el.show === 'function') {
                        this.toast = el;
                    }
                }} position="bottom-right" />
            </>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {}
});

const gradePriorityOptions = Object.entries(gradesEnum).map(([label, value]) => ({
    label: label,
    value: value
}));

export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest, fetchStudents })(Authentication(withRouter(ConfirmEnrollment)));
